<template>
    <div class="sg">
        <div class="sg-main">
            <header class="sg-project-name-bar">
                <span class="sg-project-name-icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.65">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <path d="M14 2v6h6" />
                        <path d="M8 13h8M8 17h8" />
                    </svg>
                </span>
                <h1 class="sg-project-name-title">{{ currentProject.name || '当前项目' }}</h1>
            </header>

            <el-tabs v-show="!statsTask" v-model="activeTab" @tab-click="onTabClick">
                <el-tab-pane label="任务管理" name="task" />
                <el-tab-pane label="学生管理" name="student" />
                <el-tab-pane label="试卷管理" name="paper" />
            </el-tabs>

            <!-- 任务管理 -->
            <div v-if="activeTab === 'task' && !statsTask">
                <div class="sg-stats-row">
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-total">{{ taskStats.total }}</div>
                        <div class="sg-stat-label">任务总数</div>
                    </div>
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-done">{{ taskStats.done }}</div>
                        <div class="sg-stat-label">已完成</div>
                    </div>
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-doing">{{ taskStats.doing }}</div>
                        <div class="sg-stat-label">阅卷中</div>
                    </div>
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-pending">{{ taskStats.pending }}</div>
                        <div class="sg-stat-label">未开始</div>
                    </div>
                </div>
                <div class="sg-panel">
                    <div class="sg-panel-header">
                        <el-form :inline="true" class="sg-filter-bar" @submit.native.prevent>
                            <div class="sg-filter-left">
                                <el-form-item>
                                    <el-input v-model.trim="taskQuery" size="small" clearable placeholder="搜索任务名称..."
                                        suffix-icon="el-icon-search" style="width: 240px" @input="onTaskQueryInput"
                                        @clear="onTaskQueryInput" />
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="taskStatus" size="small" placeholder="全部状态" style="width: 140px"
                                        @change="onTaskStatusChange">
                                        <el-option label="全部状态" value="" />
                                        <el-option label="阅卷中" value="doing" />
                                        <el-option label="已完成" value="done" />
                                        <el-option label="未开始" value="pending" />
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form>
                        <el-button type="primary" size="small" icon="el-icon-plus"
                            @click="startCreateTask">创建任务</el-button>
                    </div>

                    <el-table v-loading="taskLoading" :data="tasks" stripe style="width: 100%" class="sg-table-fit">
                        <el-table-column prop="name" label="任务名称" min-width="140" align="center" show-overflow-tooltip />
                        <el-table-column prop="subject" label="科目" min-width="90" align="center" />
                        <el-table-column prop="grade" label="年级" min-width="90" align="center" />
                        <el-table-column label="学生人数" min-width="100" align="center">
                            <template slot-scope="{ row }">{{ row.studentCount }}人</template>
                        </el-table-column>
                        <el-table-column label="阅卷进度" min-width="140" align="center">
                            <template slot-scope="{ row }">
                                <el-progress :percentage="row.progress" :status="progressStatus(row)" />
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" min-width="90" align="center">
                            <template slot-scope="{ row }">
                                <el-tag size="mini" :type="taskRowStatusTagType(row)">{{ taskRowStatusLabel(row)
                                    }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createdAt" label="创建时间" width="120" align="center" />
                        <el-table-column label="操作" width="240" align="center">
                            <template slot-scope="{ row }">
                                <el-button type="text" size="small" @click="startEditTask(row)">编辑
                                </el-button>
                                <el-button type="text" size="small" class="sg-delete-btn"
                                    :disabled="row.publishStatus !== 0" @click="onDeleteTask(row)">
                                    删除
                                </el-button>
                                <el-button v-if="row.publishStatus === 0" type="text" size="small"
                                    :loading="publishActionId === row.id" @click="onPublishTask(row)">
                                    发布
                                </el-button>
                                <el-button v-else type="text" size="small"
                                    :loading="publishActionId === row.id" @click="onUnpublishTask(row)">
                                    取消发布
                                </el-button>
                                <el-button type="text" size="small" :disabled="row.status !== 'done'"
                                    @click="openTaskStats(row)">查看成绩
                                </el-button>
                            </template>
                        </el-table-column>
                        <template slot="empty">
                            <el-empty description="暂无内容" />
                        </template>
                    </el-table>
                    <div v-show="taskTotal" class="sg-pagination">
                        <span class="sg-pagination-info">共 {{ taskTotal }} 条</span>
                        <pagination :total="taskTotal" :page.sync="taskPage" :limit.sync="taskPageSize"
                            :pageSizes="[10, 20, 30]" @pagination="onTaskPageChange" />
                    </div>
                </div>
            </div>

            <!-- 成绩统计 -->
            <div v-if="statsTask">
                <div class="sg-panel sg-detail-head">
                    <div>
                        <strong>{{ statsTask.name }}</strong>
                        <span class="sg-detail-sub">成绩统计</span>
                    </div>
                    <div>
                        <el-button size="small" icon="el-icon-download" @click="exportMock('成绩')">导出成绩</el-button>
                        <el-button size="small" icon="el-icon-arrow-left" @click="statsTask = null">返回任务管理</el-button>
                    </div>
                </div>
                <div class="sg-stats-row">
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-total">256</div>
                        <div class="sg-stat-label">参考人数</div>
                    </div>
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-total">98.4</div>
                        <div class="sg-stat-label">平均分</div>
                    </div>
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-done">142</div>
                        <div class="sg-stat-label">最高分</div>
                    </div>
                    <div class="sg-stat-card">
                        <div class="sg-stat-value is-doing">85.5%</div>
                        <div class="sg-stat-label">及格率</div>
                    </div>
                </div>
                <div class="sg-panel">
                    <div class="sg-panel-header">
                        <div class="sg-panel-title">成绩分布</div>
                    </div>
                    <div class="sg-chart-placeholder">
                        <div class="sg-chart-caption">成绩分布图（分数段人数统计）</div>
                        <div class="sg-chart-bar">
                            <div v-for="bar in statsBars" :key="bar.label" class="sg-bar"
                                :class="{ 'is-green': bar.green }" :style="{ height: bar.height + '%' }">
                                <span class="sg-bar-value">{{ bar.count }}</span>
                                <span class="sg-bar-label">{{ bar.label }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sg-panel">
                    <div class="sg-panel-header">
                        <div class="sg-panel-title">成绩排名</div>
                        <div>
                            <el-select v-model="statsClass" size="small" placeholder="全部班级" style="width: 140px">
                                <el-option label="全部班级" value="" />
                                <el-option v-for="cls in statsClassOptions" :key="cls" :label="cls" :value="cls" />
                            </el-select>
                            <el-button size="small" icon="el-icon-download" style="margin-left: 8px"
                                @click="exportMock('排名')">导出</el-button>
                        </div>
                    </div>
                    <el-table :data="filteredStatsRanking" stripe style="width: 100%" class="sg-table-fit">
                        <el-table-column label="排名" min-width="80" align="center">
                            <template slot-scope="{ row }">{{ rankMedal(row.rank) }}</template>
                        </el-table-column>
                        <el-table-column prop="id" label="学号" min-width="110" align="center" />
                        <el-table-column prop="name" label="姓名" min-width="90" align="center" />
                        <el-table-column prop="cls" label="班级" min-width="110" align="center" />
                        <el-table-column prop="objective" label="客观题得分" min-width="110" align="center" />
                        <el-table-column prop="subjective" label="主观题得分" min-width="110" align="center" />
                        <el-table-column prop="total" label="总分" min-width="90" align="center" />
                    </el-table>
                    <div class="sg-pagination">
                        <span class="sg-pagination-info">共 {{ filteredStatsRanking.length }} 条</span>
                    </div>
                </div>
            </div>

            <!-- 学生管理 -->
            <div v-if="activeTab === 'student'">
                <div class="sg-panel">
                    <div class="sg-panel-header">
                        <el-form :inline="true" class="sg-filter-bar" @submit.native.prevent>
                            <div class="sg-filter-left">
                                <el-form-item>
                                    <el-input v-model.trim="studentQuery" size="small" clearable
                                        placeholder="搜索姓名/学号..." suffix-icon="el-icon-search" style="width: 200px"
                                        @input="onStudentQueryInput" @clear="onStudentQueryInput" />
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="studentClass" size="small" placeholder="全部班级"
                                        style="width: 140px" @change="onStudentClassChange">
                                        <el-option label="全部班级" value="" />
                                        <el-option v-for="cls in studentClassOptions" :key="cls.classId"
                                            :label="cls.classText || cls.className" :value="cls.classId" />
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form>
                        <el-button size="small" icon="el-icon-download" :loading="studentExporting"
                            @click="exportStudentList">导出</el-button>
                    </div>

                    <el-table v-loading="studentLoading" :data="students" stripe style="width: 100%" class="sg-table-fit">
                        <el-table-column prop="studentNo" label="学号" min-width="120" align="center" />
                        <el-table-column prop="name" label="姓名" min-width="100" align="center" />
                        <el-table-column prop="cls" label="班级" min-width="120" align="center" />
                        <el-table-column label="参考场次" min-width="100" align="center">
                            <template slot-scope="{ row }">{{ row.examCount }}</template>
                        </el-table-column>
                        <el-table-column prop="subjectText" label="涉及科目" min-width="140" show-overflow-tooltip />
                        <el-table-column prop="latestTaskName" label="最近考试" min-width="160" show-overflow-tooltip />
                        <el-table-column label="操作" min-width="110" align="center">
                            <template slot-scope="{ row }">
                                <el-button type="text" size="small" @click="openStudentScore(row)">查看成绩</el-button>
                            </template>
                        </el-table-column>
                        <template slot="empty">
                            <el-empty description="暂无内容" />
                        </template>
                    </el-table>
                    <div v-show="studentTotal" class="sg-pagination">
                        <span class="sg-pagination-info">共 {{ studentTotal }} 条</span>
                        <pagination :total="studentTotal" :page.sync="studentPage" :limit.sync="studentPageSize"
                            :pageSizes="[10, 20, 30]" @pagination="onStudentPageChange" />
                    </div>
                </div>
            </div>

            <!-- 试卷管理 -->
            <div v-if="activeTab === 'paper'">
                <template v-if="!currentPaper">
                    <div class="sg-panel">
                        <el-form :inline="true" class="sg-filter-bar sg-paper-filter" @submit.native.prevent>
                            <div class="sg-filter-left">
                                <el-form-item>
                                    <el-input v-model.trim="paperQuery" size="small" clearable placeholder="搜索试卷名称..."
                                        suffix-icon="el-icon-search" style="width: 200px" @input="onPaperQueryInput"
                                        @clear="onPaperQueryInput" />
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="paperSubject" size="small" placeholder="全部学科"
                                        style="width: 140px" @change="onPaperSubjectChange">
                                        <el-option label="全部学科" value="" />
                                        <el-option v-for="sub in paperSubjectOptions" :key="sub.subjectId"
                                            :label="sub.subjectName" :value="sub.subjectId" />
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form>
                        <el-table v-loading="paperLoading" :data="papers" stripe style="width: 100%" class="sg-table-fit">
                            <el-table-column label="试卷名称" min-width="180" align="center" show-overflow-tooltip>
                                <template slot-scope="{ row }">
                                    <el-button type="text" @click="openPaperResult(row)">{{ row.name }}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="subject" label="学科" min-width="90" align="center" />
                            <el-table-column prop="questions" label="题量" min-width="70" align="center" />
                            <el-table-column prop="fullScore" label="满分" min-width="70" align="center" />
                            <el-table-column prop="answerCount" label="作答人数" min-width="90" align="center" />
                            <el-table-column prop="taskName" label="关联任务" min-width="140" show-overflow-tooltip />
                            <el-table-column label="阅卷进度" min-width="130" align="center">
                                <template slot-scope="{ row }">
                                    <el-progress :percentage="row.progress"
                                        :status="row.progress === 100 ? 'success' : undefined" />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" min-width="100" align="center">
                                <template slot-scope="{ row }">
                                    <el-button type="text" size="small" @click="openPaperResult(row)">查看结果</el-button>
                                </template>
                            </el-table-column>
                            <template slot="empty">
                                <el-empty description="暂无内容" />
                            </template>
                        </el-table>
                        <div v-show="paperTotal" class="sg-pagination">
                            <span class="sg-pagination-info">共 {{ paperTotal }} 份试卷</span>
                            <pagination :total="paperTotal" :page.sync="paperPage" :limit.sync="paperPageSize"
                                :pageSizes="[10, 20, 30]" @pagination="onPaperPageChange" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="sg-panel sg-detail-head">
                        <div>
                            <div class="sg-panel-title">{{ currentPaper.name }}</div>
                            <div class="sg-detail-sub">{{ currentPaper.subject }} · 满分 {{ currentPaper.score }} ·
                                关联任务：{{ currentPaper.taskName }}</div>
                        </div>
                        <div>
                            <el-button size="small" icon="el-icon-download" :loading="paperResultExporting"
                                @click="exportPaperResults">导出成绩</el-button>
                            <el-button size="small" icon="el-icon-arrow-left"
                                @click="backToPaperList">返回试卷列表</el-button>
                        </div>
                    </div>
                    <div class="sg-stats-row">
                        <div class="sg-stat-card">
                            <div class="sg-stat-value is-total">{{ paperResultStats.answerCount }}</div>
                            <div class="sg-stat-label">作答人数</div>
                        </div>
                        <div class="sg-stat-card">
                            <div class="sg-stat-value is-done">{{ paperResultStats.gradedCount }}</div>
                            <div class="sg-stat-label">已阅卷</div>
                        </div>
                        <div class="sg-stat-card">
                            <div class="sg-stat-value is-total">{{ paperResultStats.avg }}</div>
                            <div class="sg-stat-label">平均分</div>
                        </div>
                        <div class="sg-stat-card">
                            <div class="sg-stat-value is-doing">{{ paperResultStats.max }}</div>
                            <div class="sg-stat-label">最高分</div>
                        </div>
                    </div>
                    <div class="sg-panel">
                        <div class="sg-panel-header">
                            <div class="sg-panel-title">学生阅卷结果</div>
                        </div>
                        <el-form :inline="true" class="sg-filter-bar" @submit.native.prevent>
                            <div class="sg-filter-left">
                                <el-form-item>
                                    <el-input v-model.trim="paperResultQuery" size="small" clearable
                                        placeholder="搜索学号/姓名..." suffix-icon="el-icon-search" style="width: 180px"
                                        @input="onPaperResultQueryInput" @clear="onPaperResultQueryInput" />
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="paperResultClass" size="small" placeholder="全部班级"
                                        style="width: 140px" @change="onPaperResultFilterChange">
                                        <el-option label="全部班级" value="" />
                                        <el-option v-for="cls in paperResultClassOptions" :key="cls.classId"
                                            :label="cls.classText || cls.className" :value="cls.classId" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="paperResultStatus" size="small" placeholder="全部状态"
                                        style="width: 140px" @change="onPaperResultFilterChange">
                                        <el-option label="全部状态" value="" />
                                        <el-option label="已完成" :value="2" />
                                        <el-option label="阅卷中" :value="1" />
                                        <el-option label="待阅卷" :value="0" />
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form>
                        <el-table v-loading="paperResultLoading" :data="paperResults" stripe style="width: 100%"
                            class="sg-table-fit">
                            <el-table-column label="排名" min-width="70" align="center">
                                <template slot-scope="{ row }">{{ row.rank == null ? '—' : row.rank }}</template>
                            </el-table-column>
                            <el-table-column prop="studentNo" label="学号" min-width="110" align="center" />
                            <el-table-column prop="name" label="姓名" min-width="90" align="center" />
                            <el-table-column prop="cls" label="班级" min-width="110" align="center" />
                            <el-table-column label="客观题" min-width="80" align="center">
                                <template slot-scope="{ row }">{{ row.objective == null ? '—' : row.objective
                                    }}</template>
                            </el-table-column>
                            <el-table-column label="主观题" min-width="80" align="center">
                                <template slot-scope="{ row }">{{ row.subjective == null ? '—' : row.subjective
                                    }}</template>
                            </el-table-column>
                            <el-table-column label="总分" min-width="80" align="center">
                                <template slot-scope="{ row }">{{ row.total == null ? '—' : row.total }}</template>
                            </el-table-column>
                            <el-table-column label="状态" min-width="90" align="center">
                                <template slot-scope="{ row }">
                                    <el-tag size="mini" :type="resultTagType(row.status)">{{ row.status }}</el-tag>
                                </template>
                            </el-table-column>
                            <template slot="empty">
                                <el-empty description="暂无内容" />
                            </template>
                        </el-table>
                        <div v-show="paperResultTotal" class="sg-pagination">
                            <span class="sg-pagination-info">共 {{ paperResultTotal }} 人</span>
                            <pagination :total="paperResultTotal" :page.sync="paperResultPage"
                                :limit.sync="paperResultPageSize" :pageSizes="[10, 20, 30]"
                                @pagination="onPaperResultPageChange" />
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <el-dialog :title="isEditMode ? '编辑任务' : '创建任务'" :visible.sync="createVisible" width="920px"
            custom-class="sg-create-dialog" append-to-body :close-on-click-modal="false" @closed="closeCreateTask">
            <div class="sg-steps-wrap" :class="{ 'is-editable': isEditMode }">
                <el-steps :active="createStep - 1" align-center finish-status="success">
                    <el-step title="基本信息" :status="editStepStatus(1)" @click.native="onCreateStepClick(1)" />
                    <el-step title="导入参考学生" :status="editStepStatus(2)" @click.native="onCreateStepClick(2)" />
                    <el-step title="导入学生答题卡" :status="editStepStatus(3)" @click.native="onCreateStepClick(3)" />
                </el-steps>
            </div>

            <el-form v-show="createStep === 1" ref="createForm" :model="createForm" label-width="88px"
                class="sg-create-form">
                <div class="sg-form-section">
                    <div class="sg-form-section-title">任务与试卷</div>
                    <el-form-item label="任务名称" required>
                        <el-input v-model.trim="createForm.name" maxlength="25" show-word-limit
                            placeholder="请输入任务名称" />
                    </el-form-item>
                    <el-form-item label="筛选条件" required class="sg-filter-row-item">
                        <div class="sg-filter-row">
                            <el-select v-model="createForm.stage" placeholder="学段" class="sg-filter-stage"
                                :disabled="isTaskFilterLocked" @change="onStageChange">
                                <el-option v-for="item in stageOptions" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                            <el-select v-model="createForm.subjectId"
                                :placeholder="createForm.stage ? '学科' : '请先选学段'" class="sg-filter-subject"
                                :disabled="isTaskFilterLocked || !createForm.stage" @change="onSubjectChange">
                                <el-option v-for="sub in subjectOptions" :key="sub.id" :label="sub.name"
                                    :value="sub.id" />
                            </el-select>
                            <el-select v-model="createForm.filterGrade"
                                :placeholder="createForm.stage ? '年级' : '请先选学段'" class="sg-filter-grade"
                                :disabled="isTaskFilterLocked || !createForm.stage" @change="onFilterGradeChange">
                                <el-option v-for="g in stageGradeOptions" :key="g.value" :label="g.label"
                                    :value="g.value" />
                            </el-select>
                            <el-select v-model="createForm.spaceId" filterable
                                :placeholder="canSelectSpace ? '请选择空间' : '请先选择年级'"
                                class="sg-filter-space" :disabled="isTaskFilterLocked || !canSelectSpace"
                                :loading="spaceLoading" @change="onSpaceChange">
                                <el-option-group v-for="group in spaceGroups" :key="group.key" :label="group.label">
                                    <el-option v-for="sp in group.children" :key="sp.id"
                                        :label="sp.displayName || sp.name" :value="sp.id" />
                                </el-option-group>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="关联试卷" required>
                        <el-select v-model="createForm.paperId" filterable placeholder="请先选择空间和学科"
                            :disabled="!createForm.spaceId || !createForm.subjectId" style="width: 100%"
                            @change="onLinkedExamChange">
                            <el-option v-for="exam in paperOptions" :key="exam.id"
                                :label="exam.name + (exam.subjectName ? ' · ' + exam.subjectName : '') + (exam.totalScore != null ? ' · ' + exam.totalScore + '分' : '')"
                                :value="exam.id" />
                        </el-select>
                    </el-form-item>
                </div>

                <div class="sg-form-section">
                    <div class="sg-form-section-title">考试安排</div>
                    <el-row :gutter="16" class="sg-form-pair">
                        <el-col :span="12">
                            <el-form-item label="负责人">
                                <el-select v-model="createForm.owners" multiple filterable remote reserve-keyword
                                    collapse-tags placeholder="请选择负责人（选填）" :remote-method="searchOwners"
                                    :loading="ownerLoading" style="width: 100%">
                                    <el-option v-for="u in ownerOptions" :key="u.userId" :label="ownerLabel(u)"
                                        :value="u.userId" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="考试类型" required class="sg-pair-right">
                                <el-select v-model="createForm.examType" placeholder="请选择" style="width: 100%">
                                    <el-option v-for="item in examTypeOptions" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16" class="sg-form-pair">
                        <el-col :span="12">
                            <el-form-item label="考试年级" required>
                                <el-select v-model="createForm.grades" multiple collapse-tags
                                    :disabled="!createForm.stage"
                                    :placeholder="createForm.stage ? '请选择考试年级' : '请先选择学段'" style="width: 100%">
                                    <el-option v-for="g in stageGradeOptions" :key="g.value" :label="g.label"
                                        :value="g.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="考试班级" required class="sg-pair-right">
                                <el-select v-model="createForm.classIds" multiple collapse-tags placeholder="请选择班级"
                                    style="width: 100%">
                                    <el-option v-for="cls in classOptions" :key="cls.classId" :label="cls.className"
                                        :value="cls.classId" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16" class="sg-form-pair">
                        <el-col :span="12">
                            <el-form-item label="阅卷方式" required>
                                <el-select v-model="createForm.markMode" placeholder="请选择阅卷方式" style="width: 100%">
                                    <el-option v-for="item in gradingModeOptions" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="考试级别" required class="sg-pair-right">
                                <el-radio-group v-model="createForm.examCategory">
                                    <el-radio :label="1">单班</el-radio>
                                    <el-radio :label="2">单校</el-radio>
                                    <el-radio :label="3">联考</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16" class="sg-form-pair">
                        <el-col :span="12">
                            <el-form-item label="考试时间" required>
                                <el-date-picker v-model="createForm.examTime" type="datetimerange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm" style="width: 100%" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="阅卷时间" class="sg-pair-right">
                                <el-date-picker v-model="createForm.gradingTime" type="datetimerange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm" style="width: 100%" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16" class="sg-form-pair">
                        <el-col :span="12">
                            <el-form-item label="总分" required>
                                <el-input v-model="createForm.totalScore" placeholder="请输入总分"
                                    @input="onTotalScoreInput" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="及格分" required class="sg-pair-right">
                                <el-input v-model="createForm.passScore" placeholder="请输入及格分"
                                    @input="onPassScoreInput" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>

            <div v-show="createStep === 2" v-loading="importStudentLoading">
                <div class="sg-import-toolbar">
                    <span>导入参考学生</span>
                    <el-button size="small" icon="el-icon-download" @click="downloadTemplate">下载模板</el-button>
                </div>
                <el-upload v-show="!studentImported" class="sg-student-upload" drag action="#" :auto-upload="false"
                    :show-file-list="false" accept=".xlsx,.xls" :disabled="importStudentLoading"
                    :on-change="onImportStudents">
                    <i class="el-icon-upload" />
                    <div class="el-upload__text">点击或拖拽 Excel 文件到此处</div>
                    <div class="sg-upload-inline-tip">准考证号、姓名、年级、班级必填，座位号选填</div>
                </el-upload>
                <div v-show="studentImported">
                    <div class="sg-import-result-head">
                        <span class="ok">已导入 {{ importedStudentsTotal }} 名参考学生</span>
                        <el-button size="small" :loading="importStudentLoading"
                            @click="reimportStudents">重新导入</el-button>
                    </div>
                    <el-alert v-if="studentImportErrors.length" :title="'有 ' + studentImportErrors.length + ' 行导入失败'"
                        type="warning" :closable="false" show-icon style="margin-bottom: 12px">
                        <div v-for="(err, idx) in studentImportErrors.slice(0, 5)" :key="idx">
                            第{{ err.row }}行 {{ err.studentNo || '' }}：{{ err.reason }}
                        </div>
                    </el-alert>
                    <el-table :data="importedStudents" stripe size="small" style="width: 100%"
                        class="sg-table-fit">
                        <el-table-column prop="studentNo" label="准考证号" min-width="140" align="center" />
                        <el-table-column prop="name" label="姓名" min-width="100" align="center" />
                        <el-table-column prop="className" label="班级" min-width="120" align="center" />
                        <el-table-column prop="seatNo" label="座位号" min-width="100" align="center" />
                    </el-table>
                </div>
            </div>

            <div v-show="createStep === 3" v-loading="importSheetLoading">
                <div class="sg-import-toolbar">
                    <span>导入学生答题卡</span>
                </div>
                <el-alert v-if="sheetRecognizing && !sheetImporting" title="答题卡识别中，不能上传新文件" type="warning"
                    :closable="false" show-icon style="margin-bottom: 12px" />
                <el-alert v-if="sheetImportErrors.length && !sheetImporting"
                    :title="'有 ' + sheetImportErrors.length + ' 个文件未通过校验'" type="warning" :closable="false" show-icon
                    style="margin-bottom: 12px">
                    <div v-for="(err, idx) in sheetImportErrors.slice(0, 5)" :key="idx">{{ formatSheetImportError(err) }}
                    </div>
                </el-alert>
                <div v-show="sheetImporting" class="sg-import-pending">
                    <i class="el-icon-loading" />
                    <div>答题卡正在后台拆分，请稍候</div>
                    <p>拆分完成前不展示列表，请勿重复上传</p>
                </div>
                <el-upload v-show="!sheetImporting && !paperImported" ref="sheetUploader" drag action="#"
                    :auto-upload="false" :show-file-list="false" multiple accept=".pdf,application/pdf"
                    :disabled="importSheetLoading || sheetRecognizing" :on-change="onImportSheets">
                    <i class="el-icon-upload" />
                    <div class="el-upload__text">点击或拖拽学生答题卡到此处</div>
                    <div class="el-upload__tip" slot="tip">仅支持 PDF；多页答题卡请合并为单个 PDF；单文件不超过 20MB</div>
                </el-upload>
                <div v-show="!sheetImporting && paperImported">
                    <div class="sg-import-result-head">
                        <span class="ok">已导入 {{ importedPapersTotal }} 份学生答题卡</span>
                        <el-button size="small" :disabled="sheetRecognizing" :loading="importSheetLoading"
                            @click="continueImportSheets">重新上传</el-button>
                    </div>
                    <el-table :data="importedPapers" stripe size="small" style="width: 100%">
                        <el-table-column prop="fileName" label="文件名" min-width="160" show-overflow-tooltip />
                        <el-table-column prop="recognizeStudentNo" label="识别准考证号" width="130" align="center" />
                        <el-table-column prop="recognizeName" label="识别姓名" width="100" align="center" />
                        <el-table-column label="页数" width="120" align="center">
                            <template slot-scope="{ row }">
                                <div>{{ pageCountText(row) }}</div>
                                <el-tag v-if="row.pageStatus === 1 || row.pageStatus === 2" size="mini"
                                    :type="row.pageStatus === 1 ? 'success' : 'danger'">{{ row.pageStatus === 1 ? '正确' :
                                    '异常' }}</el-tag>
                                <span v-else class="sg-page-unchecked">未校验</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="110" align="center">
                            <template slot-scope="{ row }">
                                <el-tag size="mini" :type="paperImportTagType(row.uiStatus)">{{
                                    paperImportStatusText(row.uiStatus) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="110" align="center">
                            <template slot-scope="{ row, $index }">
                                <el-button type="text" size="small" :disabled="row.recognizeStatus === 0"
                                    @click="openRecognize(row, $index)">
                                    {{ row.uiStatus === 'ok' ? '重新识别' : '补充录入' }}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div v-show="importedPapersTotal" class="sg-pagination">
                        <span class="sg-pagination-info">共 {{ importedPapersTotal }} 份</span>
                        <pagination :total="importedPapersTotal" :page.sync="importedPapersPage"
                            :limit.sync="importedPapersPageSize" :pageSizes="[10, 20, 50]"
                            @pagination="onImportedPapersPageChange" />
                    </div>
                </div>
            </div>

            <span slot="footer" class="sg-create-footer">
                <span v-if="createStepHint" class="sg-step-hint">{{ createStepHint }}</span>
                <el-button v-show="createStep > 1" :disabled="createSaving" @click="createPrevStep">上一步</el-button>
                <el-button :disabled="createSaving" @click="createVisible = false">取 消</el-button>
                <el-button type="primary" :loading="createSaving" @click="createNextStep">{{ createStep === 3 ?
                    (isEditMode ? '保 存' : '创建任务') : '下一步' }}</el-button>
            </span>
        </el-dialog>

        <el-dialog title="考试成绩" :visible.sync="scoreVisible" width="860px" append-to-body>
            <div v-if="scoreStudent" class="sg-score-meta">
                <span>学号：<strong>{{ scoreStudent.studentNo }}</strong></span>
                <span>姓名：<strong>{{ scoreStudent.name }}</strong></span>
                <span>班级：<strong>{{ scoreStudent.cls }}</strong></span>
                <span>考试场次：<strong>{{ scoreStudent.examCount }}</strong></span>
                <span>涉及科目：<strong>{{ scoreStudent.subjectText || '—' }}</strong></span>
            </div>
            <el-form :inline="true" @submit.native.prevent>
                <el-form-item>
                    <el-select v-model="scoreSubject" size="small" placeholder="全部科目" style="width: 120px">
                        <el-option label="全部科目" value="" />
                        <el-option v-for="sub in scoreSubjectOptions" :key="sub.subjectId" :label="sub.subjectName"
                            :value="sub.subjectId" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="scoreType" size="small" placeholder="全部类型" style="width: 120px">
                        <el-option label="全部类型" value="" />
                        <el-option v-for="item in examTypeOptions" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-form>
            <el-table v-loading="scoreLoading" :data="filteredScoreExams" stripe style="width: 100%">
                <el-table-column prop="name" label="考试名称" min-width="180" show-overflow-tooltip />
                <el-table-column prop="subject" label="科目" width="80" align="center" />
                <el-table-column prop="type" label="考试类型" width="100" align="center" />
                <el-table-column prop="date" label="考试时间" width="120" align="center" />
                <el-table-column label="客观题" width="80" align="center">
                    <template slot-scope="{ row }">{{ row.objective == null ? '—' : row.objective }}</template>
                </el-table-column>
                <el-table-column label="主观题" width="80" align="center">
                    <template slot-scope="{ row }">{{ row.subjective == null ? '—' : row.subjective }}</template>
                </el-table-column>
                <el-table-column label="总分" width="80" align="center">
                    <template slot-scope="{ row }">{{ row.total == null ? '—' : row.total }}</template>
                </el-table-column>
                <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="{ row }">
                        <el-tag size="mini" :type="resultTagType(row.status)">{{ row.status }}</el-tag>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <el-empty description="暂无内容" />
                </template>
            </el-table>
            <span slot="footer">
                <el-button @click="scoreVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="recognizeTitle" :visible.sync="recognizeVisible" width="720px" append-to-body>
            <el-alert v-if="recognizeFailTip" :title="recognizeFailTip" type="error" :closable="false" show-icon
                style="margin-bottom: 16px" />
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="sg-recognize-label">答卷预览</div>
                    <div class="sg-recognize-preview">
                        <img v-if="recognizePreviewIsImage" :src="sheetPreviewUrl(recognizeForm.fileUrl)" alt=""
                            class="sg-recognize-img" />
                        <template v-else>
                            <i class="el-icon-document" style="font-size: 40px; color: #c0c4cc" />
                            <div>{{ recognizeForm.file }}</div>
                            <p class="sg-recognize-hint">{{ recognizeForm.fileUrl ? '点击下方预览原图查看答卷' : '暂无预览' }}</p>
                        </template>
                    </div>
                    <div style="margin-top: 12px">
                        <el-button size="small" :loading="recognizeSaving" @click="retryRecognize">重新识别</el-button>
                        <el-button size="small" :disabled="!recognizeForm.fileUrl"
                            @click="previewSheetFile">预览原图</el-button>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="sg-recognize-label">学生信息录入</div>
                    <el-form label-position="top">
                        <el-form-item label="班级" required>
                            <el-select v-model="recognizeForm.cls" placeholder="请选择班级" style="width: 100%"
                                @change="onRecognizeClassChange">
                                <el-option v-for="cls in recognizeClassOptions" :key="cls" :label="cls" :value="cls" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="姓名" required>
                            <el-select v-model="recognizeForm.studentNo" filterable placeholder="请先选择班级"
                                :disabled="!recognizeForm.cls" style="width: 100%">
                                <el-option v-for="s in recognizeNameOptions" :key="s.studentNo"
                                    :label="s.name + '（' + s.studentNo + '）'" :value="s.studentNo" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="准考证号" required>
                            <el-input v-model="recognizeForm.studentNo" placeholder="选择学生后自动带出" />
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="recognizeForm.note" type="textarea" :rows="3" placeholder="选填" />
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer">
                <el-button @click="recognizeVisible = false">取 消</el-button>
                <el-button type="primary" :loading="recognizeSaving" @click="saveRecognize">保存并确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import SparkMD5 from 'spark-md5';
    import { saveAs } from 'file-saver';
    import pagination from '@/common/community/pagination.vue';
    import {
        STATS_RANKING,
        STATS_BARS,
    } from './space-grading-mock';

    const OSS = require('ali-oss');

    const DISPLAY_STATUS = { 0: 'pending', 1: 'doing', 2: 'done' };
    const STATUS_CODE = { pending: 0, doing: 1, done: 2 };
    const EXAM_TYPE_OPTIONS = [
        { value: 1, label: '周考' },
        { value: 2, label: '月考' },
        { value: 3, label: '期中考试' },
        { value: 4, label: '期末考试' },
        { value: 5, label: '模拟考试' },
        { value: 6, label: '其他' },
        { value: 7, label: '单元测验' },
    ];
    const GRADING_MODE_OPTIONS = [
        { value: 1, label: '网上阅卷（客观自动 + 主观人工）' },
        { value: 2, label: '全部人工阅卷' },
        { value: 3, label: '仅客观题自动评分' },
        { value: 4, label: '线下阅卷录入' },
    ];
    const STAGE_OPTIONS = [
        { value: 1, label: '小学' },
        { value: 2, label: '初中' },
        { value: 3, label: '九年一贯制' },
        { value: 4, label: '高中' },
        { value: 7, label: '十二年一贯制' },
    ];
    const GRADE_MAP = {
        1: [
            { value: 1, label: '一年级' },
            { value: 2, label: '二年级' },
            { value: 3, label: '三年级' },
            { value: 4, label: '四年级' },
            { value: 5, label: '五年级' },
            { value: 6, label: '六年级' },
        ],
        2: [
            { value: 7, label: '初一' },
            { value: 8, label: '初二' },
            { value: 9, label: '初三' },
        ],
        3: [
            { value: 1, label: '一年级' },
            { value: 2, label: '二年级' },
            { value: 3, label: '三年级' },
            { value: 4, label: '四年级' },
            { value: 5, label: '五年级' },
            { value: 6, label: '六年级' },
            { value: 7, label: '初一' },
            { value: 8, label: '初二' },
            { value: 9, label: '初三' },
        ],
        4: [
            { value: 10, label: '高一' },
            { value: 11, label: '高二' },
            { value: 12, label: '高三' },
        ],
        7: [
            { value: 1, label: '一年级' },
            { value: 2, label: '二年级' },
            { value: 3, label: '三年级' },
            { value: 4, label: '四年级' },
            { value: 5, label: '五年级' },
            { value: 6, label: '六年级' },
            { value: 7, label: '初一' },
            { value: 8, label: '初二' },
            { value: 9, label: '初三' },
            { value: 10, label: '高一' },
            { value: 11, label: '高二' },
            { value: 12, label: '高三' },
        ],
    };
    const clampScoreInput = (raw) => {
        let text = String(raw == null ? '' : raw).replace(/[^\d.]/g, '');
        const firstDot = text.indexOf('.');
        if (firstDot !== -1) {
            text = text.slice(0, firstDot + 1) + text.slice(firstDot + 1).replace(/\./g, '');
        }
        const parts = text.split('.');
        let intPart = (parts[0] || '').slice(0, 3);
        if (parts.length > 1) {
            return intPart + '.' + parts[1].slice(0, 2);
        }
        return intPart;
    };
    const toMinuteValue = (t) => {
        if (!t) return '';
        const s = String(t);
        return s.length >= 16 ? s.slice(0, 16) : s;
    };
    const withSeconds = (t) => {
        if (!t) return '';
        const s = String(t);
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) return s;
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(s)) return s + ':00';
        return s;
    };
    const truncateName = (name) => String(name || '').slice(0, 25);
    const inferStageByGrade = (grade) => {
        const g = Number(grade);
        if (g >= 1 && g <= 6) return 1;
        if (g >= 7 && g <= 9) return 2;
        if (g >= 10 && g <= 12) return 4;
        return '';
    };
    const SUBJECT_OPTIONS = [
        { id: 1, name: '语文' },
        { id: 2, name: '数学' },
        { id: 3, name: '英语' },
        { id: 4, name: '物理' },
        { id: 5, name: '化学' },
        { id: 6, name: '生物学' },
        { id: 7, name: '政治（道法）' },
        { id: 8, name: '历史' },
        { id: 9, name: '地理' },
        { id: 10, name: '科学' },
        { id: 11, name: '历史与社会' },
        { id: 12, name: '信息技术' },
        { id: 13, name: '音乐' },
        { id: 14, name: '美术' },
        { id: 15, name: '体育与健康' },
        { id: 16, name: '通用技术' },
        { id: 17, name: '劳动技术' },
        { id: 18, name: '拓展' },
        { id: 19, name: '心理健康' },
        { id: 20, name: '综合实践活动' },
        { id: 21, name: '日语' },
        { id: 22, name: '俄语' },
        { id: 23, name: '书法' },
        { id: 24, name: '社会' },
        { id: 25, name: '职教专业课' },
        { id: 26, name: '藏语' },
        { id: 27, name: '西班牙语' },
        { id: 28, name: '德语' },
        { id: 29, name: '法语' },
        { id: 30, name: '地方课程' },
    ];

    const unwrapApi = (res) => {
        if (!res) return res;
        if (res.status != null && res.data && typeof res.data === 'object' && 'code' in res.data) {
            return res.data;
        }
        return res;
    };
    const isApiOk = (res) => {
        const body = unwrapApi(res);
        return body && (body.code === 0 || body.code === 200);
    };
    const apiMsg = (res) => {
        const body = unwrapApi(res);
        return (body && body.msg) || '';
    };
    const apiData = (res) => {
        const body = unwrapApi(res);
        return body && body.data;
    };

    const emptyCreateForm = () => ({
        name: '',
        stage: '',
        filterGrade: '',
        spaceId: '',
        subjectId: '',
        paperId: '',
        owners: [],
        examType: '',
        grades: [],
        classIds: [],
        markMode: 1,
        examTime: [],
        gradingTime: [],
        examCategory: 2,
        totalScore: '100',
        passScore: '60',
    });

    export default {
        name: 'SpaceGrading',
        components: { pagination },
        data() {
            return {
                activeTab: 'task',
                statusText: { doing: '阅卷中', done: '已完成', pending: '未开始' },
                tasks: [],
                taskTotal: 0,
                taskLoading: false,
                taskStats: { total: 0, done: 0, doing: 0, pending: 0 },
                students: [],
                studentTotal: 0,
                studentLoading: false,
                studentExporting: false,
                studentClassOptions: [],
                papers: [],
                paperTotal: 0,
                paperLoading: false,
                paperResultExporting: false,
                paperSubjectOptions: [],
                paperResults: [],
                paperResultTotal: 0,
                paperResultLoading: false,
                paperResultPage: 1,
                paperResultPageSize: 10,
                paperResultClassOptions: [],
                paperResultStats: { answerCount: 0, gradedCount: 0, avg: '—', max: '—' },
                scoreLoading: false,
                statsBars: STATS_BARS,
                statsRanking: STATS_RANKING,
                spaceOptions: [],
                spaceLoading: false,
                stageOptions: STAGE_OPTIONS,
                subjectOptions: SUBJECT_OPTIONS,
                paperOptions: [],
                ownerOptions: [],
                ownerLoading: false,
                classOptions: [],
                examTypeOptions: EXAM_TYPE_OPTIONS,
                gradingModeOptions: GRADING_MODE_OPTIONS,
                taskQuery: '',
                taskStatus: '',
                taskPage: 1,
                taskPageSize: 10,
                statsTask: null,
                statsClass: '',
                studentQuery: '',
                studentClass: '',
                studentPage: 1,
                studentPageSize: 10,
                paperQuery: '',
                paperSubject: '',
                paperPage: 1,
                paperPageSize: 10,
                currentPaper: null,
                paperResultQuery: '',
                paperResultClass: '',
                paperResultStatus: '',
                createVisible: false,
                isEditMode: false,
                savedTaskId: '',
                createSaving: false,
                createStep: 1,
                createForm: emptyCreateForm(),
                passScoreManual: false,
                studentImported: false,
                paperImported: false,
                importStudentLoading: false,
                importSheetLoading: false,
                sheetImporting: false,
                sheetRecognizing: false,
                sheetImportAwaiting: false,
                sheetImportSeen: false,
                sheetImportMissCount: 0,
                studentImportErrors: [],
                sheetImportErrors: [],
                importedStudents: [],
                importedStudentsTotal: 0,
                importedPapers: [],
                importedPapersTotal: 0,
                importedPapersPage: 1,
                importedPapersPageSize: 10,
                scoreVisible: false,
                scoreStudent: null,
                scoreSubject: '',
                scoreType: '',
                recognizeVisible: false,
                recognizeIndex: -1,
                recognizeSaving: false,
                recognizeForm: { sheetId: '', file: '', fileUrl: '', cls: '', studentNo: '', note: '' },
                recognizeFailTip: '',
                ossClient: null,
                _taskQueryTimer: null,
                _studentQueryTimer: null,
                _paperQueryTimer: null,
                _paperResultQueryTimer: null,
                _sheetPickTimer: null,
                _sheetPollTimer: null,
                publishActionId: '',
            };
        },
        computed: {
            ...mapState({
                currentProject: (state) => state.user.currentProject,
            }),
            statsClassOptions() {
                const map = {};
                this.statsRanking.forEach((row) => { map[row.cls] = true; });
                return Object.keys(map);
            },
            filteredStatsRanking() {
                if (!this.statsClass) return this.statsRanking;
                return this.statsRanking.filter((row) => row.cls === this.statsClass);
            },
            isTaskFilterLocked() {
                return !!this.savedTaskId;
            },
            stageGradeOptions() {
                return GRADE_MAP[this.createForm.stage] || [];
            },
            canSelectSpace() {
                return !!(this.createForm.stage && this.createForm.subjectId && this.createForm.filterGrade !== ''
                    && this.createForm.filterGrade != null);
            },
            spaceGroups() {
                const map = {};
                const order = [];
                (this.spaceOptions || []).forEach((item) => {
                    const key = item.parentId != null ? String(item.parentId) : (item.parentName || 'other');
                    if (!map[key]) {
                        map[key] = {
                            key,
                            label: item.parentName || '未分组',
                            children: [],
                        };
                        order.push(map[key]);
                    }
                    map[key].children.push(item);
                });
                return order;
            },
            createStepHint() {
                if (this.createStep === 1) return '请填写考试基本信息并选择试卷';
                if (this.createStep === 2) {
                    return this.studentImported ? '已导入参考学生，可进入下一步' : '请导入参考学生名单（Excel）';
                }
                if (this.sheetImporting) return '答题卡正在后台拆分，完成后自动显示列表';
                if (this.sheetRecognizing) return '答题卡识别中，暂不能上传新文件';
                return this.paperImported ? '已导入学生答题卡，确认无误后创建任务' : '请导入学生答题卡（仅 PDF）后确认创建';
            },
            scoreSubjectOptions() {
                if (!this.scoreStudent) return [];
                const ids = this.scoreStudent.subjectIds || [];
                const names = this.scoreStudent.subjectNames || [];
                if (ids.length) {
                    return ids.map((id, i) => ({
                        subjectId: id,
                        subjectName: names[i] || String(id),
                    }));
                }
                return names.map((name) => ({ subjectId: name, subjectName: name }));
            },
            filteredScoreExams() {
                if (!this.scoreStudent) return [];
                return (this.scoreStudent.exams || []).filter((ex) => {
                    if (this.scoreSubject !== '' && this.scoreSubject != null
                        && String(ex.subjectId) !== String(this.scoreSubject)) return false;
                    if (this.scoreType !== '' && this.scoreType != null
                        && Number(ex.examType) !== Number(this.scoreType)) return false;
                    return true;
                });
            },
            recognizeClassOptions() {
                const map = {};
                this.importedStudents.forEach((row) => {
                    if (row.className) map[row.className] = true;
                });
                return Object.keys(map);
            },
            recognizeNameOptions() {
                return this.importedStudents.filter((s) => s.className === this.recognizeForm.cls);
            },
            recognizeTitle() {
                const row = this.importedPapers[this.recognizeIndex];
                return row && row.uiStatus === 'ok' ? '重新识别学生信息' : '补充录入学生信息';
            },
            recognizePreviewIsImage() {
                const name = (this.recognizeForm.file || '').toLowerCase();
                const url = (this.recognizeForm.fileUrl || '').toLowerCase();
                return /\.(png|jpe?g|gif|webp)(\?|$)/.test(name)
                    || /\.(png|jpe?g|gif|webp)(\?|$)/.test(url)
                    || /_(png|jpe?g|gif|webp)$/.test(url);
            },
        },
        watch: {
            'currentProject.id': {
                immediate: true,
                handler() {
                    this.resetStudentPaperState();
                    this.initTaskModule();
                    this.loadActiveTabData();
                },
            },
        },
        beforeDestroy() {
            this.clearTaskQueryTimer();
            this.clearTimer('_studentQueryTimer');
            this.clearTimer('_paperQueryTimer');
            this.clearTimer('_paperResultQueryTimer');
            this.stopSheetPoll();
            if (this._sheetPickTimer) clearTimeout(this._sheetPickTimer);
        },
        methods: {
            onTabClick(tab) {
                this.statsTask = null;
                if (!tab || tab.name !== 'paper') this.currentPaper = null;
                this.loadActiveTabData(tab && tab.name);
            },
            statusTagType(status) {
                if (status === 'done') return 'success';
                if (status === 'doing') return '';
                return 'info';
            },
            taskRowStatusLabel(row) {
                if (row.publishStatus === 0) return '未发布';
                return this.statusText[row.status] || '—';
            },
            taskRowStatusTagType(row) {
                if (row.publishStatus === 0) return 'info';
                return this.statusTagType(row.status);
            },
            progressStatus(row) {
                if (row.status === 'done' || row.progress === 100) return 'success';
                return undefined;
            },
            resultTagType(status) {
                if (status === '已完成') return 'success';
                if (status === '阅卷中') return '';
                return 'info';
            },
            paperImportTagType(status) {
                if (status === 'ok') return 'success';
                if (status === 'pending' || status === 'recognizing') return 'warning';
                return 'danger';
            },
            paperImportStatusText(status) {
                if (status === 'ok') return '识别成功';
                if (status === 'pending') return '待确认';
                if (status === 'recognizing') return '识别中';
                return '识别失败';
            },
            ownerLabel(user) {
                if (!user) return '';
                return user.subjectName ? user.name + ' · ' + user.subjectName : user.name;
            },
            mapTaskRow(row) {
                const created = row.createTime ? String(row.createTime).slice(0, 10) : '';
                const publishStatus = Number(row.status) === 1 ? 1 : 0;
                return {
                    ...row,
                    subject: row.subjectName || '—',
                    grade: row.gradeText || '—',
                    studentCount: row.studentCount || 0,
                    progress: row.progressPercent || 0,
                    publishStatus,
                    status: DISPLAY_STATUS[row.displayStatus] || 'pending',
                    createdAt: created,
                    examId: row.paperId,
                };
            },
            mapSheetRow(row) {
                let uiStatus = 'ok';
                if (row.recognizeStatus === 0) uiStatus = 'recognizing';
                else if (row.recognizeStatus === 2) uiStatus = 'fail';
                else if (row.recognizeStatus === 3 || row.pageStatus === 2 || row.matchStatus === 2 || row.matchStatus === 3) uiStatus = 'pending';
                return {
                    ...row,
                    fileName: row.fileName || '—',
                    recognizeStudentNo: row.recognizeStudentNo || '—',
                    recognizeName: row.recognizeName || '—',
                    uiStatus,
                };
            },
            pageCountText(row) {
                if (!row || (row.pageCount == null && row.expectedPageCount == null)) return '—';
                const actual = row.pageCount == null ? '—' : row.pageCount;
                const expected = row.expectedPageCount == null ? '—' : row.expectedPageCount;
                return actual + '/' + expected;
            },
            formatSheetImportError(err) {
                if (err == null) return '';
                if (typeof err === 'string') return err;
                const name = err.fileName || '';
                const reason = err.reason || err.msg || err.message || '';
                if (name && reason) return name + '：' + reason;
                return name || reason;
            },
            async initTaskModule() {
                this.taskPage = 1;
                await Promise.all([
                    this.fetchClassOptions(),
                    this.fetchTaskList(),
                    this.fetchTaskStats(),
                ]);
            },
            async fetchClassOptions() {
                try {
                    const res = await this.$Api.ExamTask.getOptions();
                    if (!isApiOk(res)) {
                        this.classOptions = [];
                        return;
                    }
                    const data = apiData(res) || {};
                    this.classOptions = data.classes || [];
                } catch (e) {
                    this.classOptions = [];
                }
            },
            async loadComposeSpaces() {
                const projectId = this.currentProject && this.currentProject.id;
                if (!projectId || !this.createForm.stage || !this.createForm.subjectId) {
                    this.spaceOptions = [];
                    return;
                }
                this.spaceLoading = true;
                try {
                    const res = await this.$Api.ExamCompose.getSpaces({
                        projectId,
                        stage: this.createForm.stage,
                        subjectId: this.createForm.subjectId,
                    });
                    if (!isApiOk(res)) {
                        this.spaceOptions = [];
                        return;
                    }
                    const list = apiData(res);
                    this.spaceOptions = (Array.isArray(list) ? list : []).map((item) => ({
                        id: item.spxId,
                        name: item.displayName || item.spxName || '',
                        displayName: item.displayName || item.spxName || '',
                        parentId: item.parentId,
                        parentName: item.parentName,
                        spxId: item.spxId,
                        spxName: item.spxName,
                    }));
                } catch (e) {
                    this.spaceOptions = [];
                } finally {
                    this.spaceLoading = false;
                }
            },
            mergeSelectedSpace(space) {
                if (!space || space.id == null) return;
                const exists = this.spaceOptions.some((item) => String(item.id) === String(space.id));
                if (!exists) this.spaceOptions.push(space);
            },
            async fetchTaskList() {
                if (!this.currentProject || !this.currentProject.id) {
                    this.tasks = [];
                    this.taskTotal = 0;
                    return;
                }
                this.taskLoading = true;
                try {
                    const params = {
                        projectId: this.currentProject.id,
                        page: this.taskPage,
                        pageSize: this.taskPageSize,
                    };
                    if (this.taskQuery) params.name = this.taskQuery;
                    if (this.taskStatus) params.status = STATUS_CODE[this.taskStatus];
                    const res = await this.$Api.ExamTask.getProjectList(params);
                    if (!isApiOk(res)) {
                        this.tasks = [];
                        this.taskTotal = 0;
                        this.$message.error(apiMsg(res) || '获取任务列表失败');
                        return;
                    }
                    const data = apiData(res) || {};
                    this.tasks = (data.records || []).map(this.mapTaskRow);
                    this.taskTotal = data.totalCount || 0;
                } catch (e) {
                    this.tasks = [];
                    this.taskTotal = 0;
                    this.$message.error('获取任务列表失败');
                } finally {
                    this.taskLoading = false;
                }
            },
            async fetchTaskStats() {
                if (!this.currentProject || !this.currentProject.id) {
                    this.taskStats = { total: 0, done: 0, doing: 0, pending: 0 };
                    return;
                }
                try {
                    const projectId = this.currentProject.id;
                    const [allRes, pendingRes, doingRes, doneRes] = await Promise.all([
                        this.$Api.ExamTask.getProjectList({ projectId, page: 1, pageSize: 1 }),
                        this.$Api.ExamTask.getProjectList({ projectId, page: 1, pageSize: 1, status: 0 }),
                        this.$Api.ExamTask.getProjectList({ projectId, page: 1, pageSize: 1, status: 1 }),
                        this.$Api.ExamTask.getProjectList({ projectId, page: 1, pageSize: 1, status: 2 }),
                    ]);
                    this.taskStats = {
                        total: isApiOk(allRes) ? ((apiData(allRes) || {}).totalCount || 0) : 0,
                        pending: isApiOk(pendingRes) ? ((apiData(pendingRes) || {}).totalCount || 0) : 0,
                        doing: isApiOk(doingRes) ? ((apiData(doingRes) || {}).totalCount || 0) : 0,
                        done: isApiOk(doneRes) ? ((apiData(doneRes) || {}).totalCount || 0) : 0,
                    };
                } catch (e) {
                    this.taskStats = { total: 0, done: 0, doing: 0, pending: 0 };
                }
            },
            clearTaskQueryTimer() {
                if (this._taskQueryTimer) {
                    clearTimeout(this._taskQueryTimer);
                    this._taskQueryTimer = null;
                }
            },
            onTaskQueryInput() {
                this.clearTaskQueryTimer();
                this._taskQueryTimer = setTimeout(() => {
                    this.taskPage = 1;
                    this.fetchTaskList();
                }, 400);
            },
            onTaskStatusChange() {
                this.taskPage = 1;
                this.fetchTaskList();
            },
            onTaskPageChange() {
                this.fetchTaskList();
            },
            onStudentPageChange({ pageIndex, pageSize } = {}) {
                if (pageIndex) this.studentPage = pageIndex;
                if (pageSize) this.studentPageSize = pageSize;
                this.fetchStudentList();
            },
            onPaperPageChange({ pageIndex, pageSize } = {}) {
                if (pageIndex) this.paperPage = pageIndex;
                if (pageSize) this.paperPageSize = pageSize;
                this.fetchPaperList();
            },
            rankMedal(rank) {
                if (rank === 1) return '1';
                if (rank === 2) return '2';
                if (rank === 3) return '3';
                return String(rank);
            },
            notifyTaskBlocked(title, message) {
                this.$notify({
                    title,
                    message,
                    duration: 2500,
                    customClass: 'sg-task-notify',
                    showClose: true,
                });
            },
            openTaskStats(row) {
                if (row.status === 'doing') {
                    this.notifyTaskBlocked(
                        '暂时无法查看成绩',
                        '该任务阅卷尚未完成，请待阅卷结束后再查看成绩。',
                    );
                    return;
                }
                this.statsTask = row;
                this.statsClass = '';
            },
            emptyPaperResultStats() {
                return { answerCount: 0, gradedCount: 0, avg: '—', max: '—' };
            },
            resetStudentPaperState() {
                this.students = [];
                this.studentTotal = 0;
                this.studentClassOptions = [];
                this.studentQuery = '';
                this.studentClass = '';
                this.studentPage = 1;
                this.papers = [];
                this.paperTotal = 0;
                this.paperSubjectOptions = [];
                this.paperQuery = '';
                this.paperSubject = '';
                this.paperPage = 1;
                this.currentPaper = null;
                this.paperResults = [];
                this.paperResultTotal = 0;
                this.paperResultQuery = '';
                this.paperResultClass = '';
                this.paperResultStatus = '';
                this.paperResultPage = 1;
                this.paperResultClassOptions = [];
                this.paperResultStats = this.emptyPaperResultStats();
            },
            loadActiveTabData(tabName) {
                const name = tabName || this.activeTab;
                if (name === 'student') this.fetchStudentList();
                if (name === 'paper' && !this.currentPaper) this.fetchPaperList();
            },
            projectId() {
                return this.currentProject && this.currentProject.id;
            },
            clearTimer(key) {
                if (this[key]) {
                    clearTimeout(this[key]);
                    this[key] = null;
                }
            },
            debounce(key, fn, wait) {
                this.clearTimer(key);
                this[key] = setTimeout(fn, wait || 400);
            },
            mapProjectStudent(row) {
                return {
                    ...row,
                    studentNo: row.studentNo,
                    name: row.name || '—',
                    cls: row.classText || row.className || '—',
                    examCount: row.examCount || 0,
                    subjectText: row.subjectText || (row.subjectNames || []).join('、') || '—',
                    latestTaskName: row.latestTaskName || '—',
                    subjectIds: row.subjectIds || [],
                    subjectNames: row.subjectNames || [],
                };
            },
            mapProjectPaper(row) {
                return {
                    ...row,
                    paperId: row.paperId,
                    name: row.paperName,
                    subject: row.subjectName || '—',
                    questions: row.questionCount == null ? '—' : row.questionCount,
                    score: row.fullScore == null ? '—' : row.fullScore,
                    answerCount: row.answerCount || 0,
                    taskName: row.taskText || (row.taskNames || []).join('、') || '—',
                    progress: row.progressPercent || 0,
                };
            },
            mapPaperStudent(row) {
                return {
                    ...row,
                    rank: row.rank,
                    studentNo: row.studentNo,
                    name: row.name || '—',
                    cls: row.classText || row.className || '—',
                    objective: row.objectiveScore,
                    subjective: row.subjectiveScore,
                    total: row.totalScore,
                    status: row.displayStatusName || '待阅卷',
                };
            },
            mapStudentExam(row) {
                return {
                    ...row,
                    name: row.taskName,
                    subject: row.subjectName || '—',
                    type: row.examTypeName || '—',
                    date: row.examStart ? String(row.examStart).slice(0, 10) : '—',
                    objective: row.objectiveScore,
                    subjective: row.subjectiveScore,
                    total: row.totalScore,
                    status: row.displayStatusName || '待阅卷',
                    subjectId: row.subjectId,
                    examType: row.examType,
                };
            },
            buildStudentListParams(page, pageSize) {
                const params = {
                    projectId: this.projectId(),
                    page: page || this.studentPage,
                    pageSize: pageSize || this.studentPageSize,
                };
                if (this.studentQuery) params.keyword = this.studentQuery;
                if (this.studentClass !== '' && this.studentClass != null) params.classId = this.studentClass;
                return params;
            },
            buildPaperListParams(page, pageSize) {
                const params = {
                    projectId: this.projectId(),
                    page: page || this.paperPage,
                    pageSize: pageSize || this.paperPageSize,
                };
                if (this.paperQuery) params.keyword = this.paperQuery;
                if (this.paperSubject !== '' && this.paperSubject != null) params.subjectId = this.paperSubject;
                return params;
            },
            buildPaperStudentParams(page, pageSize) {
                const params = {
                    projectId: this.projectId(),
                    paperId: this.currentPaper && this.currentPaper.paperId,
                    page: page || this.paperResultPage,
                    pageSize: pageSize || this.paperResultPageSize,
                };
                if (this.paperResultQuery) params.keyword = this.paperResultQuery;
                if (this.paperResultClass !== '' && this.paperResultClass != null) {
                    params.classId = this.paperResultClass;
                }
                if (this.paperResultStatus !== '' && this.paperResultStatus != null) {
                    params.status = this.paperResultStatus;
                }
                return params;
            },
            async fetchStudentList() {
                if (!this.projectId()) {
                    this.students = [];
                    this.studentTotal = 0;
                    this.studentClassOptions = [];
                    return;
                }
                this.studentLoading = true;
                try {
                    const res = await this.$Api.ExamTask.getProjectStudentList(this.buildStudentListParams());
                    if (!isApiOk(res)) {
                        this.students = [];
                        this.studentTotal = 0;
                        this.$message.error(apiMsg(res) || '获取学生列表失败');
                        return;
                    }
                    const data = apiData(res) || {};
                    this.students = (data.records || []).map(this.mapProjectStudent);
                    this.studentTotal = data.totalCount || 0;
                    this.studentClassOptions = data.classes || [];
                } catch (e) {
                    this.students = [];
                    this.studentTotal = 0;
                    this.$message.error('获取学生列表失败');
                } finally {
                    this.studentLoading = false;
                }
            },
            async fetchPaperList() {
                if (!this.projectId()) {
                    this.papers = [];
                    this.paperTotal = 0;
                    this.paperSubjectOptions = [];
                    return;
                }
                this.paperLoading = true;
                try {
                    const res = await this.$Api.ExamTask.getProjectPaperList(this.buildPaperListParams());
                    if (!isApiOk(res)) {
                        this.papers = [];
                        this.paperTotal = 0;
                        this.$message.error(apiMsg(res) || '获取试卷列表失败');
                        return;
                    }
                    const data = apiData(res) || {};
                    this.papers = (data.records || []).map(this.mapProjectPaper);
                    this.paperTotal = data.totalCount || 0;
                    this.paperSubjectOptions = data.subjects || [];
                } catch (e) {
                    this.papers = [];
                    this.paperTotal = 0;
                    this.$message.error('获取试卷列表失败');
                } finally {
                    this.paperLoading = false;
                }
            },
            applyPaperStudentData(data) {
                this.paperResults = (data.records || []).map(this.mapPaperStudent);
                this.paperResultTotal = data.totalCount || 0;
                this.paperResultClassOptions = data.classes || [];
                this.paperResultStats = {
                    answerCount: data.answerCount || 0,
                    gradedCount: data.gradedCount || 0,
                    avg: data.avgScore == null ? '—' : data.avgScore,
                    max: data.maxScore == null ? '—' : data.maxScore,
                };
                if (this.currentPaper) {
                    this.currentPaper = {
                        ...this.currentPaper,
                        name: data.paperName || this.currentPaper.name,
                        subject: data.subjectName || this.currentPaper.subject,
                        score: data.fullScore != null ? data.fullScore : this.currentPaper.score,
                    };
                }
            },
            async fetchPaperStudents() {
                if (!this.projectId() || !this.currentPaper || !this.currentPaper.paperId) {
                    this.paperResults = [];
                    this.paperResultTotal = 0;
                    this.paperResultClassOptions = [];
                    this.paperResultStats = this.emptyPaperResultStats();
                    return;
                }
                this.paperResultLoading = true;
                try {
                    const res = await this.$Api.ExamTask.getProjectPaperStudentList(this.buildPaperStudentParams());
                    if (!isApiOk(res)) {
                        this.paperResults = [];
                        this.paperResultTotal = 0;
                        this.paperResultStats = this.emptyPaperResultStats();
                        this.$message.error(apiMsg(res) || '获取试卷作答学生失败');
                        return;
                    }
                    this.applyPaperStudentData(apiData(res) || {});
                } catch (e) {
                    this.paperResults = [];
                    this.paperResultTotal = 0;
                    this.paperResultStats = this.emptyPaperResultStats();
                    this.$message.error('获取试卷作答学生失败');
                } finally {
                    this.paperResultLoading = false;
                }
            },
            onStudentQueryInput() {
                this.debounce('_studentQueryTimer', () => {
                    this.studentPage = 1;
                    this.fetchStudentList();
                });
            },
            onStudentClassChange() {
                this.studentPage = 1;
                this.fetchStudentList();
            },
            onPaperQueryInput() {
                this.debounce('_paperQueryTimer', () => {
                    this.paperPage = 1;
                    this.fetchPaperList();
                });
            },
            onPaperSubjectChange() {
                this.paperPage = 1;
                this.fetchPaperList();
            },
            onPaperResultQueryInput() {
                this.debounce('_paperResultQueryTimer', () => {
                    this.paperResultPage = 1;
                    this.fetchPaperStudents();
                });
            },
            onPaperResultFilterChange() {
                this.paperResultPage = 1;
                this.fetchPaperStudents();
            },
            onPaperResultPageChange({ pageIndex, pageSize } = {}) {
                if (pageIndex) this.paperResultPage = pageIndex;
                if (pageSize) this.paperResultPageSize = pageSize;
                this.fetchPaperStudents();
            },
            async openStudentScore(row) {
                this.scoreStudent = {
                    studentNo: row.studentNo,
                    name: row.name,
                    cls: row.cls,
                    examCount: row.examCount || 0,
                    subjectText: row.subjectText || '—',
                    subjectIds: row.subjectIds || [],
                    subjectNames: row.subjectNames || [],
                    exams: [],
                };
                this.scoreSubject = '';
                this.scoreType = '';
                this.scoreVisible = true;
                this.scoreLoading = true;
                try {
                    const res = await this.$Api.ExamTask.getProjectStudentScore({
                        projectId: this.projectId(),
                        studentNo: row.studentNo,
                    });
                    if (!isApiOk(res)) {
                        this.$message.error(apiMsg(res) || '获取学生成绩失败');
                        return;
                    }
                    const data = apiData(res) || {};
                    this.scoreStudent = {
                        studentNo: data.studentNo || row.studentNo,
                        name: data.name || row.name,
                        cls: data.classText || data.className || row.cls,
                        examCount: data.examCount != null ? data.examCount : row.examCount || 0,
                        subjectText: data.subjectText || (data.subjectNames || []).join('、') || row.subjectText || '—',
                        subjectIds: data.subjectIds || row.subjectIds || [],
                        subjectNames: data.subjectNames || row.subjectNames || [],
                        exams: (data.exams || []).map(this.mapStudentExam),
                    };
                } catch (e) {
                    this.$message.error('获取学生成绩失败');
                } finally {
                    this.scoreLoading = false;
                }
            },
            openPaperResult(row) {
                this.currentPaper = row;
                this.paperResultQuery = '';
                this.paperResultClass = '';
                this.paperResultStatus = '';
                this.paperResultPage = 1;
                this.paperResults = [];
                this.paperResultTotal = 0;
                this.paperResultClassOptions = [];
                this.paperResultStats = this.emptyPaperResultStats();
                this.fetchPaperStudents();
            },
            backToPaperList() {
                this.currentPaper = null;
                this.paperResults = [];
                this.paperResultTotal = 0;
                this.paperResultClassOptions = [];
                this.paperResultStats = this.emptyPaperResultStats();
            },
            escapeCsv(value) {
                const str = value == null ? '' : String(value);
                if (/[",\n\r]/.test(str)) return '"' + str.replace(/"/g, '""') + '"';
                return str;
            },
            exportStamp() {
                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                const d = new Date();
                return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + '_'
                    + pad(d.getHours()) + pad(d.getMinutes());
            },
            downloadCsv(filename, headers, rows) {
                const lines = [headers.map(this.escapeCsv).join(',')].concat(
                    rows.map((row) => row.map(this.escapeCsv).join(','))
                );
                saveAs(new Blob(['\uFEFF' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' }), filename);
            },
            displayDash(value) {
                return value == null || value === '' ? '—' : value;
            },
            async fetchAllPages(request) {
                const pageSize = 100;
                const first = await request(1, pageSize);
                if (!first) return [];
                const total = first.totalCount || 0;
                let records = (first.records || []).slice();
                const pages = Math.ceil(total / pageSize);
                for (let page = 2; page <= pages; page++) {
                    const data = await request(page, pageSize);
                    records = records.concat((data && data.records) || []);
                }
                return records;
            },
            async requestStudentPage(page, pageSize) {
                const res = await this.$Api.ExamTask.getProjectStudentList(this.buildStudentListParams(page, pageSize));
                if (!isApiOk(res)) throw new Error(apiMsg(res) || '获取学生列表失败');
                return apiData(res) || {};
            },
            async requestPaperStudentPage(page, pageSize) {
                const res = await this.$Api.ExamTask.getProjectPaperStudentList(this.buildPaperStudentParams(page, pageSize));
                if (!isApiOk(res)) throw new Error(apiMsg(res) || '获取试卷作答学生失败');
                return apiData(res) || {};
            },
            async exportStudentList() {
                if (!this.projectId()) return;
                this.studentExporting = true;
                try {
                    const records = await this.fetchAllPages((page, pageSize) => this.requestStudentPage(page, pageSize));
                    if (!records.length) {
                        this.$message.warning('当前筛选结果为空，无法导出');
                        return;
                    }
                    const rows = records.map(this.mapProjectStudent).map((row) => [
                        row.studentNo,
                        row.name,
                        row.cls,
                        row.examCount,
                        row.subjectText,
                        row.latestTaskName,
                    ]);
                    const clsItem = this.studentClassOptions.find((c) => String(c.classId) === String(this.studentClass));
                    const clsName = clsItem ? (clsItem.classText || clsItem.className) : '全部班级';
                    this.downloadCsv(
                        '学生管理_' + clsName + '_' + this.exportStamp() + '.csv',
                        ['学号', '姓名', '班级', '参考场次', '涉及科目', '最近考试'],
                        rows
                    );
                    this.$message.success('已导出 ' + rows.length + ' 条学生数据');
                } catch (e) {
                    this.$message.error((e && e.message) || '导出失败');
                } finally {
                    this.studentExporting = false;
                }
            },
            async exportPaperResults() {
                if (!this.projectId() || !this.currentPaper) return;
                this.paperResultExporting = true;
                try {
                    const records = await this.fetchAllPages((page, pageSize) => this.requestPaperStudentPage(page, pageSize));
                    if (!records.length) {
                        this.$message.warning('当前筛选结果为空，无法导出');
                        return;
                    }
                    const rows = records.map(this.mapPaperStudent).map((row) => [
                        this.displayDash(row.rank),
                        row.studentNo,
                        row.name,
                        row.cls,
                        this.displayDash(row.objective),
                        this.displayDash(row.subjective),
                        this.displayDash(row.total),
                        row.status,
                    ]);
                    const paperName = String(this.currentPaper.name || '试卷').replace(/[\\/:*?"<>|]/g, '_');
                    this.downloadCsv(
                        paperName + '_成绩_' + this.exportStamp() + '.csv',
                        ['排名', '学号', '姓名', '班级', '客观题', '主观题', '总分', '状态'],
                        rows
                    );
                    this.$message.success('已导出 ' + rows.length + ' 条成绩');
                } catch (e) {
                    this.$message.error((e && e.message) || '导出失败');
                } finally {
                    this.paperResultExporting = false;
                }
            },
            exportMock(name) {
                this.$message.success('已导出' + name + '（示例）');
            },
            async downloadTemplate() {
                const href = (process.env.BASE_URL || '/') + 'templates/spx-exam-student-import.xlsx';
                try {
                    const res = await fetch(href);
                    if (!res.ok) {
                        this.$message.error('模板下载失败');
                        return;
                    }
                    const blob = await res.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = '考生导入模板.xlsx';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.setTimeout(() => window.URL.revokeObjectURL(url), 2000);
                } catch (e) {
                    this.$message.error('模板下载失败');
                }
            },
            defaultExamTime() {
                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                const d = new Date();
                const day = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
                return [day + ' 08:00', day + ' 11:30'];
            },
            async searchOwners(name) {
                if (!this.createForm.spaceId) {
                    this.ownerOptions = [];
                    return;
                }
                this.ownerLoading = true;
                try {
                    const params = { spxId: this.createForm.spaceId };
                    if (this.currentProject && this.currentProject.id) params.projectId = this.currentProject.id;
                    if (name) params.name = name;
                    const res = await this.$Api.ExamTask.getOwnerList(params);
                    const list = isApiOk(res) ? (apiData(res) || []) : [];
                    const selected = this.ownerOptions.filter((u) =>
                        this.createForm.owners.some((id) => String(id) === String(u.userId))
                    );
                    const map = {};
                    selected.concat(list).forEach((u) => { map[u.userId] = u; });
                    this.ownerOptions = Object.keys(map).map((id) => map[id]);
                } catch (e) {
                    this.ownerOptions = [];
                } finally {
                    this.ownerLoading = false;
                }
            },
            startCreateTask() {
                this.isEditMode = false;
                this.savedTaskId = '';
                this.createStep = 1;
                this.createForm = emptyCreateForm();
                this.createForm.examTime = this.defaultExamTime();
                this.passScoreManual = false;
                this.resetImportState();
                this.spaceOptions = [];
                this.paperOptions = [];
                this.ownerOptions = [];
                this.createVisible = true;
            },
            async startEditTask(row) {
                this.isEditMode = true;
                this.savedTaskId = row.id;
                this.createStep = 1;
                this.createForm = emptyCreateForm();
                this.passScoreManual = true;
                this.resetImportState();
                this.createVisible = true;
                this.createSaving = true;
                try {
                    const res = await this.$Api.ExamTask.getDetail({ id: row.id });
                    if (!isApiOk(res)) {
                        this.$message.error(apiMsg(res) || '获取任务详情失败');
                        this.createVisible = false;
                        return;
                    }
                    await this.fillCreateForm(apiData(res) || {});
                    await Promise.all([
                        this.searchOwners(''),
                        this.fetchPaperOptions(),
                        this.fetchImportedStudents(),
                        this.fetchImportedSheets(),
                    ]);
                } catch (e) {
                    this.$message.error('获取任务详情失败');
                    this.createVisible = false;
                } finally {
                    this.createSaving = false;
                }
            },
            async fillCreateForm(detail) {
                const grades = (detail.grades || []).slice();
                const stage = detail.stage || inferStageByGrade(grades[0]);
                this.createForm = {
                    name: truncateName(detail.name || ''),
                    stage: stage || '',
                    filterGrade: grades.length ? grades[0] : '',
                    spaceId: detail.spxId || '',
                    subjectId: detail.subjectId || '',
                    paperId: detail.paperId || '',
                    owners: (detail.ownerUserIds || []).slice(),
                    examType: detail.examType === 0 || detail.examType ? detail.examType : '',
                    grades,
                    classIds: (detail.classIds || []).slice(),
                    markMode: detail.markMode || 1,
                    examTime: detail.examStart && detail.examEnd
                        ? [toMinuteValue(detail.examStart), toMinuteValue(detail.examEnd)]
                        : this.defaultExamTime(),
                    gradingTime: detail.markStart && detail.markEnd
                        ? [toMinuteValue(detail.markStart), toMinuteValue(detail.markEnd)]
                        : [],
                    examCategory: detail.examCategory || 2,
                    totalScore: detail.totalScore != null ? String(detail.totalScore) : '100',
                    passScore: detail.passScore != null ? String(detail.passScore) : '60',
                };
                if (detail.paperName) {
                    this.paperOptions = [{
                        id: detail.paperId,
                        name: detail.paperName,
                        subjectName: detail.subjectName,
                        totalScore: detail.totalScore,
                    }];
                }
                if (this.createForm.stage && this.createForm.subjectId) {
                    await this.loadComposeSpaces();
                    this.mergeSelectedSpace({
                        id: detail.spxId,
                        name: detail.spxName || detail.spaceName || '',
                        displayName: detail.spxName || detail.spaceName || '',
                        parentName: detail.parentName || '未分组',
                    });
                }
                this.studentImported = (detail.studentCount || 0) > 0;
                this.importedStudentsTotal = detail.studentCount || 0;
                this.paperImported = (detail.sheetCount || 0) > 0;
                this.importedPapersTotal = detail.sheetCount || 0;
            },
            resetImportState() {
                this.studentImported = false;
                this.paperImported = false;
                this.importedStudents = [];
                this.importedStudentsTotal = 0;
                this.importedPapers = [];
                this.importedPapersTotal = 0;
                this.importedPapersPage = 1;
                this.studentImportErrors = [];
                this.sheetImportErrors = [];
                this.sheetImporting = false;
                this.sheetRecognizing = false;
                this.sheetImportAwaiting = false;
                this.sheetImportSeen = false;
                this.sheetImportMissCount = 0;
                this.stopSheetPoll();
            },
            closeCreateTask() {
                this.isEditMode = false;
                this.savedTaskId = '';
                this.createSaving = false;
                this.stopSheetPoll();
                this.fetchTaskList();
                this.fetchTaskStats();
            },
            onStageChange() {
                if (this.isTaskFilterLocked) return;
                this.createForm.filterGrade = '';
                this.createForm.grades = [];
                this.createForm.spaceId = '';
                this.createForm.subjectId = '';
                this.createForm.paperId = '';
                this.createForm.owners = [];
                this.spaceOptions = [];
                this.paperOptions = [];
                this.ownerOptions = [];
            },
            onFilterGradeChange() {
                if (this.isTaskFilterLocked) return;
                if (this.createForm.filterGrade !== '' && this.createForm.filterGrade != null) {
                    this.createForm.grades = [this.createForm.filterGrade];
                } else {
                    this.createForm.grades = [];
                }
                this.createForm.spaceId = '';
                this.createForm.paperId = '';
                this.createForm.owners = [];
                this.paperOptions = [];
                this.ownerOptions = [];
                if (this.createForm.stage && this.createForm.subjectId) this.loadComposeSpaces();
                else this.spaceOptions = [];
            },
            onSpaceChange() {
                this.createForm.paperId = '';
                this.createForm.owners = [];
                this.paperOptions = [];
                this.ownerOptions = [];
                if (this.createForm.spaceId) {
                    this.searchOwners('');
                    if (this.createForm.subjectId) this.fetchPaperOptions();
                }
            },
            onSubjectChange() {
                if (this.isTaskFilterLocked) return;
                this.createForm.spaceId = '';
                this.createForm.paperId = '';
                this.createForm.owners = [];
                this.paperOptions = [];
                this.ownerOptions = [];
                if (this.createForm.stage && this.createForm.subjectId) this.loadComposeSpaces();
                else this.spaceOptions = [];
            },
            async fetchPaperOptions() {
                if (!this.createForm.spaceId || !this.createForm.subjectId) {
                    this.paperOptions = [];
                    return;
                }
                try {
                    const res = await this.$Api.ExamTask.getPaperList({
                        spxId: this.createForm.spaceId,
                        subjectId: this.createForm.subjectId,
                    });
                    const list = isApiOk(res) ? (apiData(res) || []) : [];
                    this.paperOptions = list.map((item) => ({
                        id: item.paperId,
                        name: item.name,
                        subjectName: item.subjectName,
                        totalScore: item.totalScore,
                    }));
                } catch (e) {
                    this.paperOptions = [];
                }
            },
            onLinkedExamChange() {
                const exam = this.paperOptions.find((p) => p.id === this.createForm.paperId);
                if (!exam) return;
                if (!this.createForm.name) this.createForm.name = truncateName(exam.name);
                if (exam.totalScore != null) {
                    this.createForm.totalScore = clampScoreInput(String(exam.totalScore));
                    if (!this.passScoreManual) {
                        this.createForm.passScore = clampScoreInput(String(Math.round(exam.totalScore * 0.6)));
                    }
                }
            },
            onTotalScoreInput(val) {
                this.createForm.totalScore = clampScoreInput(val);
                const total = parseFloat(this.createForm.totalScore);
                if (!this.passScoreManual && !isNaN(total) && total > 0) {
                    this.createForm.passScore = clampScoreInput(String(Math.round(total * 0.6)));
                }
            },
            onPassScoreInput(val) {
                this.passScoreManual = true;
                this.createForm.passScore = clampScoreInput(val);
            },
            buildTaskPayload(status) {
                const f = this.createForm;
                const payload = {
                    projectId: this.currentProject && this.currentProject.id,
                    spxId: f.spaceId,
                    name: truncateName(f.name),
                    stage: f.stage,
                    examType: f.examType,
                    subjectId: f.subjectId,
                    paperId: f.paperId,
                    ownerUserIds: f.owners || [],
                    markMode: f.markMode,
                    examCategory: f.examCategory,
                    examStart: withSeconds(f.examTime && f.examTime[0]),
                    examEnd: withSeconds(f.examTime && f.examTime[1]),
                    totalScore: Number(f.totalScore),
                    passScore: Number(f.passScore),
                    grades: f.grades || [],
                    classIds: f.classIds || [],
                };
                if (this.savedTaskId) payload.id = this.savedTaskId;
                if (status === 0 || status === 1) payload.status = status;
                if (f.gradingTime && f.gradingTime.length === 2 && f.gradingTime[0] && f.gradingTime[1]) {
                    payload.markStart = withSeconds(f.gradingTime[0]);
                    payload.markEnd = withSeconds(f.gradingTime[1]);
                }
                return payload;
            },
            validateCreateStep() {
                const f = this.createForm;
                if (this.createStep === 1) {
                    if (!f.name) { this.$message.warning('请填写任务名称'); return false; }
                    if (String(f.name).length > 25) { this.$message.warning('任务名称最多 25 个字'); return false; }
                    if (!f.stage) { this.$message.warning('请选择学段'); return false; }
                    if (!f.subjectId) { this.$message.warning('请选择学科'); return false; }
                    if (f.filterGrade === '' || f.filterGrade == null) { this.$message.warning('请选择年级'); return false; }
                    if (!f.spaceId) { this.$message.warning('请先选择空间'); return false; }
                    if (!f.paperId) { this.$message.warning('请选择该空间 · 学科下的关联试卷'); return false; }
                    if (!f.examType && f.examType !== 0) { this.$message.warning('请选择考试类型'); return false; }
                    if (!f.grades.length) { this.$message.warning('请选择考试年级'); return false; }
                    if (!f.classIds.length) { this.$message.warning('请至少选择一个班级'); return false; }
                    if (!f.markMode) { this.$message.warning('请选择阅卷方式'); return false; }
                    if (!f.examTime || f.examTime.length !== 2) { this.$message.warning('请设置考试时间'); return false; }
                    const totalScore = parseFloat(f.totalScore);
                    const passScore = parseFloat(f.passScore);
                    if (isNaN(totalScore) || totalScore <= 0) { this.$message.warning('请填写有效总分'); return false; }
                    if (isNaN(passScore) || passScore < 0) { this.$message.warning('请填写有效及格分'); return false; }
                    if (passScore > totalScore) { this.$message.warning('及格分不能大于总分'); return false; }
                }
                return true;
            },
            async createNextStep() {
                if (!this.validateCreateStep()) return;
                if (this.createStep === 1) {
                    const ok = await this.saveTask(this.isEditMode ? undefined : 0);
                    if (!ok) return;
                    this.createStep = 2;
                    this.fetchImportedStudents();
                    return;
                }
                if (this.createStep < 3) {
                    this.createStep += 1;
                    if (this.createStep === 3) this.fetchImportedSheets();
                    return;
                }
                this.confirmCreateTask();
            },
            editStepStatus(step) {
                if (!this.isEditMode) return '';
                return this.createStep === step ? 'process' : 'success';
            },
            onCreateStepClick(step) {
                if (!this.isEditMode || this.createSaving || step === this.createStep) return;
                if (this.createStep === 3) this.stopSheetPoll();
                this.createStep = step;
                if (step === 2) this.fetchImportedStudents();
                if (step === 3) this.fetchImportedSheets();
            },
            createPrevStep() {
                if (this.createStep === 3) this.stopSheetPoll();
                if (this.createStep > 1) this.createStep -= 1;
            },
            async saveTask(status) {
                this.createSaving = true;
                try {
                    const res = await this.$Api.ExamTask.save(this.buildTaskPayload(status));
                    if (!isApiOk(res)) {
                        this.$message.error(apiMsg(res) || '保存任务失败');
                        return false;
                    }
                    const id = apiData(res);
                    if (id && !this.savedTaskId) this.savedTaskId = id;
                    return true;
                } catch (e) {
                    this.$message.error('保存任务失败');
                    return false;
                } finally {
                    this.createSaving = false;
                }
            },
            async confirmCreateTask() {
                const ok = await this.saveTask(undefined);
                if (!ok) return;
                this.$message.success(this.isEditMode
                    ? '阅卷任务「' + this.createForm.name + '」已保存'
                    : '阅卷任务「' + this.createForm.name + '」已保存，请在列表中发布后在空间阅卷展示');
                this.taskPage = 1;
                this.createVisible = false;
            },
            onPublishTask(row) {
                if (!row || !row.id || row.publishStatus === 1) return;
                this.$confirm(
                    '发布后，结对空间成员可在空间阅卷中看到任务「' + row.name + '」。确定发布？',
                    '发布任务',
                    { type: 'info', confirmButtonText: '发布', cancelButtonText: '取消' },
                ).then(async () => {
                    this.publishActionId = row.id;
                    try {
                        const res = await this.$Api.ExamTask.publish({ id: row.id });
                        if (!isApiOk(res)) {
                            this.$message.error(apiMsg(res) || '发布失败');
                            return;
                        }
                        this.$message.success('已发布「' + row.name + '」');
                        await this.fetchTaskList();
                        await this.fetchTaskStats();
                    } catch (e) {
                        this.$message.error('发布失败');
                    } finally {
                        this.publishActionId = '';
                    }
                }).catch(() => { });
            },
            onUnpublishTask(row) {
                if (!row || !row.id || row.publishStatus !== 1) return;
                this.$confirm(
                    '取消发布后，空间阅卷将不再展示任务「' + row.name + '」。确定取消？',
                    '取消发布',
                    { type: 'warning', confirmButtonText: '确定', cancelButtonText: '取消' },
                ).then(async () => {
                    this.publishActionId = row.id;
                    try {
                        const res = await this.$Api.ExamTask.unpublish({ id: row.id });
                        if (!isApiOk(res)) {
                            this.$message.error(apiMsg(res) || '取消发布失败');
                            return;
                        }
                        this.$message.success('已取消发布，当前为未发布');
                        await this.fetchTaskList();
                        await this.fetchTaskStats();
                    } catch (e) {
                        this.$message.error('取消发布失败');
                    } finally {
                        this.publishActionId = '';
                    }
                }).catch(() => { });
            },
            onPublishTask(row) {
                if (!row || !row.id || row.publishStatus === 1) return;
                this.$confirm(
                    '发布后，结对空间成员可在空间阅卷中看到任务「' + row.name + '」。确定发布？',
                    '发布任务',
                    { type: 'info', confirmButtonText: '发布', cancelButtonText: '取消' },
                ).then(async () => {
                    this.publishActionId = row.id;
                    try {
                        const res = await this.$Api.ExamTask.publish({ id: row.id });
                        if (!isApiOk(res)) {
                            this.$message.error(apiMsg(res) || '发布失败');
                            return;
                        }
                        this.$message.success('已发布「' + row.name + '」');
                        await this.fetchTaskList();
                        await this.fetchTaskStats();
                    } catch (e) {
                        this.$message.error('发布失败');
                    } finally {
                        this.publishActionId = '';
                    }
                }).catch(() => { });
            },
            onUnpublishTask(row) {
                if (!row || !row.id || row.publishStatus !== 1) return;
                this.$confirm(
                    '取消发布后，空间阅卷将不再展示任务「' + row.name + '」。确定取消？',
                    '取消发布',
                    { type: 'warning', confirmButtonText: '确定', cancelButtonText: '取消' },
                ).then(async () => {
                    this.publishActionId = row.id;
                    try {
                        const res = await this.$Api.ExamTask.unpublish({ id: row.id });
                        if (!isApiOk(res)) {
                            this.$message.error(apiMsg(res) || '取消发布失败');
                            return;
                        }
                        this.$message.success('已取消发布，当前为未发布');
                        await this.fetchTaskList();
                        await this.fetchTaskStats();
                    } catch (e) {
                        this.$message.error('取消发布失败');
                    } finally {
                        this.publishActionId = '';
                    }
                }).catch(() => { });
            },
            onDeleteTask(row) {
                // 【修改】未发布可删；已发布限制删除（不再按阅卷进度拦截）
                if (row.publishStatus !== 0) {
                    this.notifyTaskBlocked(
                        '暂时无法删除',
                        '该任务已发布，暂时无法删除。如需删除请先取消发布。',
                    );
                    return;
                }
                this.$confirm('确定删除任务「' + row.name + '」吗？', '提示', {
                    type: 'warning',
                }).then(async () => {
                    try {
                        const res = await this.$Api.ExamTask.delete({ id: row.id });
                        if (!isApiOk(res)) {
                            this.$message.error(apiMsg(res) || '删除失败');
                            return;
                        }
                        this.$message.success('已删除');
                        if (this.tasks.length === 1 && this.taskPage > 1) this.taskPage -= 1;
                        this.fetchTaskList();
                        this.fetchTaskStats();
                    } catch (e) {
                        this.$message.error('删除失败');
                    }
                }).catch(() => { });
            },
            async fetchImportedStudents() {
                if (!this.savedTaskId) return;
                try {
                    const res = await this.$Api.ExamTask.getStudentList({
                        taskId: this.savedTaskId,
                        page: 1,
                        pageSize: 100,
                    });
                    if (!isApiOk(res)) return;
                    const data = apiData(res) || {};
                    this.importedStudents = data.records || [];
                    this.importedStudentsTotal = data.totalCount || this.importedStudents.length;
                    this.studentImported = this.importedStudentsTotal > 0;
                } catch (e) {
                    this.importedStudents = [];
                }
            },
            async fetchImportedSheets() {
                if (!this.savedTaskId) return;
                const seq = (this._sheetListSeq || 0) + 1;
                this._sheetListSeq = seq;
                try {
                    const res = await this.$Api.ExamTask.getStudentSheetList({
                        taskId: this.savedTaskId,
                        page: this.importedPapersPage,
                        pageSize: this.importedPapersPageSize,
                    });
                    if (seq !== this._sheetListSeq || !isApiOk(res)) return;
                    const data = apiData(res) || {};
                    const recognizing = data.recognizing === true || data.recognizing === 1;
                    const importing = data.importing === true || data.importing === 1;
                    this.sheetRecognizing = recognizing;
                    if (importing) {
                        this.sheetImportSeen = true;
                        this.sheetImportMissCount = 0;
                        this.sheetImporting = true;
                        this.syncSheetPoll();
                        return;
                    }
                    // 提交后短暂读不到 importing：继续等；已进入识别则拆分已结束
                    if (this.sheetImportAwaiting && !this.sheetImportSeen && !recognizing) {
                        this.sheetImportMissCount += 1;
                        if (this.sheetImportMissCount < 5) {
                            this.sheetImporting = true;
                            this.syncSheetPoll();
                            return;
                        }
                    }
                    const finishedImport = this.sheetImportAwaiting && (this.sheetImportSeen || recognizing || this.sheetImportMissCount >= 5);
                    this.sheetImportAwaiting = false;
                    this.sheetImportSeen = false;
                    this.sheetImportMissCount = 0;
                    this.sheetImporting = false;
                    this.importedPapers = (data.records || []).map(this.mapSheetRow);
                    this.importedPapersTotal = data.totalCount || 0;
                    this.paperImported = this.importedPapersTotal > 0;
                    if (finishedImport) {
                        this.$message.success(this.importedPapersTotal
                            ? '答题卡拆分完成，共 ' + this.importedPapersTotal + ' 份'
                            : '答题卡处理完成，未生成可识别的答题卡');
                    }
                    this.syncSheetPoll();
                } catch (e) {
                    if (seq !== this._sheetListSeq || this.sheetImporting) return;
                    this.importedPapers = [];
                }
            },
            onImportedPapersPageChange({ pageIndex, pageSize } = {}) {
                if (pageIndex) this.importedPapersPage = pageIndex;
                if (pageSize) this.importedPapersPageSize = pageSize;
                this.fetchImportedSheets();
            },
            syncSheetPoll() {
                const pending = this.sheetImporting || this.sheetImportAwaiting || this.sheetRecognizing
                    || this.importedPapers.some((row) => row.recognizeStatus === 0);
                if (pending && this.createVisible && this.createStep === 3) this.startSheetPoll();
                else this.stopSheetPoll();
            },
            startSheetPoll() {
                if (this._sheetPollTimer) return;
                this._sheetPollTimer = setInterval(() => {
                    this.fetchImportedSheets();
                }, 1000);
            },
            stopSheetPoll() {
                if (this._sheetPollTimer) {
                    clearInterval(this._sheetPollTimer);
                    this._sheetPollTimer = null;
                }
            },
            onImportStudents(file) {
                const raw = file && (file.raw || file);
                if (!raw) return;
                const name = String(raw.name || '').toLowerCase();
                if (!name.endsWith('.xlsx') && !name.endsWith('.xls')) {
                    this.$message.warning('请上传 Excel 文件（.xlsx / .xls）');
                    return;
                }
                this.importStudentFile(raw);
            },
            reimportStudents() {
                this.studentImported = false;
            },
            async importStudentFile(file) {
                if (!this.savedTaskId) {
                    this.$message.warning('请先保存任务基本信息');
                    return;
                }
                this.importStudentLoading = true;
                try {
                    const res = await this.$Api.ExamTask.importStudents({
                        taskId: this.savedTaskId,
                        file,
                    });
                    if (!isApiOk(res)) {
                        this.$message.error(apiMsg(res) || '导入考生失败');
                        return;
                    }
                    const data = apiData(res) || {};
                    this.studentImportErrors = data.errors || [];
                    await this.fetchImportedStudents();
                    this.$message.success('成功导入 ' + (data.successCount || this.importedStudentsTotal) + ' 名参考学生'
                        + (data.failCount ? '，失败 ' + data.failCount + ' 行' : ''));
                } catch (e) {
                    this.$message.error('导入考生失败');
                } finally {
                    this.importStudentLoading = false;
                }
            },
            onImportSheets(file, fileList) {
                if (this.sheetRecognizing || this.sheetImporting) return;
                if (this._sheetPickTimer) clearTimeout(this._sheetPickTimer);
                this._sheetPickTimer = setTimeout(() => {
                    const files = (fileList || []).map((item) => item.raw || item).filter(Boolean);
                    if (this.$refs.sheetUploader) this.$refs.sheetUploader.clearFiles();
                    this.importSheetFiles(files);
                }, 200);
            },
            continueImportSheets() {
                if (this.sheetRecognizing) {
                    this.$message.warning('答题卡识别中，不能上传新文件');
                    return;
                }
                if (this.sheetImporting) {
                    this.$message.warning('答题卡导入处理中，请稍后再试');
                    return;
                }
                const openUpload = () => {
                    this.paperImported = false;
                    this.sheetImportErrors = [];
                };
                if (!this.importedPapersTotal) {
                    openUpload();
                    return;
                }
                this.$confirm('重新上传将覆盖该任务已导入的答题卡，确定继续？', '重新上传', {
                    type: 'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(openUpload).catch(() => { });
            },
            clearSheetUpload() {
                const upload = this.$refs.sheetUploader;
                if (upload && upload.clearFiles) upload.clearFiles();
            },
            async ensureOssClient() {
                const res = await this.$Api.OssUpload.getQueryToken();
                if (!isApiOk(res) || !apiData(res)) {
                    throw new Error(apiMsg(res) || '获取上传凭证失败');
                }
                const token = apiData(res);
                this.ossClient = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: token.accessKeyId,
                    accessKeySecret: token.accessKeySecret,
                    bucket: token.bucket,
                    stsToken: token.stsToken,
                });
                return this.ossClient;
            },
            computeFileIdentifier(file) {
                return new Promise((resolve, reject) => {
                    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                    const chunkSize = 10 * 1024 * 1024;
                    const chunks = Math.ceil(file.size / chunkSize) || 1;
                    let currentChunk = 0;
                    const spark = new SparkMD5.ArrayBuffer();
                    const fileReader = new FileReader();
                    const ext = (() => {
                        const idx = String(file.name || '').lastIndexOf('.');
                        return idx >= 0 ? file.name.substring(idx + 1) : '';
                    })();
                    fileReader.onload = (e) => {
                        spark.append(e.target.result);
                        currentChunk += 1;
                        if (currentChunk < chunks) {
                            loadNext();
                            return;
                        }
                        const md5 = spark.end();
                        resolve({
                            identifier: md5 + '_' + file.size + '_' + ext,
                            ext,
                            filename: String(file.name || 'sheet').replace(/\+/g, '_'),
                            totalSize: file.size,
                            type: file.type,
                        });
                    };
                    fileReader.onerror = () => reject(new Error('读取文件失败'));
                    const loadNext = () => {
                        const start = currentChunk * chunkSize;
                        const end = Math.min(start + chunkSize, file.size);
                        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                    };
                    loadNext();
                });
            },
            async uploadFileToOss(file) {
                const meta = await this.computeFileIdentifier(file);
                const projectId = this.currentProject && this.currentProject.id;
                const checkRes = await this.$Api.OssUpload.getCheck({
                    identifier: meta.identifier,
                    projectId,
                    filename: meta.filename,
                });
                if (!isApiOk(checkRes)) {
                    throw new Error(apiMsg(checkRes) || '文件校验失败');
                }
                const checkData = apiData(checkRes) || {};
                if (checkData.check && checkData.fileInfo) {
                    return {
                        fileName: file.name,
                        ossUrl: meta.identifier,
                    };
                }
                const client = await this.ensureOssClient();
                const filePath = 'upload/' + this.dayjs().format('YYYY/MM/DD') + '/' + meta.identifier + '/' + meta.filename;
                await client.put(filePath, file);
                const mergeRes = await this.$Api.OssUpload.postMerge({
                    filename: meta.filename,
                    identifier: meta.identifier,
                    totalSize: meta.totalSize,
                    type: meta.type,
                    location: filePath,
                    ext: meta.ext,
                    projectId,
                });
                if (!isApiOk(mergeRes)) {
                    throw new Error(apiMsg(mergeRes) || '文件登记失败');
                }
                return {
                    fileName: file.name,
                    ossUrl: meta.identifier,
                };
            },
            sheetPreviewUrl(url) {
                if (!url) return '';
                if (/^https?:\/\//i.test(url)) return url;
                return this.downloadURL + url;
            },
            async importSheetFiles(files) {
                if (!files.length) return;
                if (this.sheetRecognizing) {
                    this.$message.warning('答题卡识别中，不能上传新文件');
                    this.clearSheetUpload();
                    return;
                }
                if (this.sheetImporting) {
                    this.$message.warning('答题卡导入处理中，请稍后再试');
                    this.clearSheetUpload();
                    return;
                }
                if (!this.savedTaskId) {
                    this.$message.warning('请先保存任务基本信息');
                    return;
                }
                const valid = [];
                const rejected = [];
                files.forEach((file) => {
                    const name = String(file.name || '');
                    if (!name.toLowerCase().endsWith('.pdf')) {
                        rejected.push(name || '未命名文件');
                        return;
                    }
                    if (file.size > 20 * 1024 * 1024) {
                        this.$message.warning(name + ' 超过 20MB，已跳过');
                        return;
                    }
                    valid.push(file);
                });
                if (rejected.length) {
                    this.$message.warning('仅支持 PDF，已跳过：' + rejected.join('、'));
                }
                if (!valid.length) {
                    this.clearSheetUpload();
                    return;
                }
                this.importSheetLoading = true;
                this.sheetImportErrors = [];
                try {
                    const uploaded = [];
                    for (let i = 0; i < valid.length; i++) {
                        uploaded.push(await this.uploadFileToOss(valid[i]));
                    }
                    const res = await this.$Api.ExamTask.importStudentSheets({
                        taskId: this.savedTaskId,
                        files: uploaded,
                    });
                    if (!isApiOk(res)) {
                        this.$message.error(apiMsg(res) || '导入答题卡失败');
                        return;
                    }
                    const data = apiData(res) || {};
                    if (data.async === true) {
                        this.sheetImportAwaiting = true;
                        this.sheetImportSeen = false;
                        this.sheetImportMissCount = 0;
                        this.sheetImporting = true;
                        this.paperImported = false;
                        this.importedPapersPage = 1;
                        this.$message.success('已提交后台处理，正在拆分答题卡');
                        this.startSheetPoll();
                        await this.fetchImportedSheets();
                        return;
                    }
                    this.sheetImportErrors = Array.isArray(data.errors) ? data.errors : [];
                    if (this.sheetImportErrors.length) {
                        this.$message.warning('有 ' + this.sheetImportErrors.length + ' 个文件未通过校验');
                    }
                    await this.fetchImportedSheets();
                    this.$message.success('成功导入 ' + (data.successCount || uploaded.length) + ' 份学生答题卡'
                        + (data.failCount ? '，失败 ' + data.failCount + ' 份' : ''));
                } catch (e) {
                    this.$message.error((e && e.message) || '导入答题卡失败');
                } finally {
                    this.importSheetLoading = false;
                    this.clearSheetUpload();
                }
            },
            openRecognize(paper, idx) {
                this.recognizeIndex = idx;
                const cls = this.importedStudents.find((s) =>
                    s.studentNo === paper.recognizeStudentNo || s.name === paper.recognizeName
                );
                this.recognizeForm = {
                    sheetId: paper.sheetId,
                    file: paper.fileName,
                    fileUrl: paper.fileUrl || '',
                    cls: cls ? cls.className : (this.recognizeClassOptions[0] || ''),
                    studentNo: paper.recognizeStudentNo && paper.recognizeStudentNo !== '—' ? paper.recognizeStudentNo : '',
                    note: paper.remark || '',
                };
                let tip = '';
                if (paper.pageStatus === 2) {
                    const actual = paper.pageCount == null ? '—' : paper.pageCount;
                    const expected = paper.expectedPageCount == null ? '—' : paper.expectedPageCount;
                    tip = '页数异常（实际 ' + actual + ' 页，应答 ' + expected + ' 页），需人工核对后确认';
                    if (paper.remark) tip += '；' + paper.remark;
                } else if (paper.uiStatus === 'fail') {
                    tip = paper.remark || '条形码模糊，准考证号/姓名无法识别';
                } else if (paper.uiStatus === 'pending') {
                    tip = paper.remark || '准考证号识别不完整，需人工核对';
                }
                this.recognizeFailTip = tip;
                this.recognizeVisible = true;
            },
            onRecognizeClassChange() {
                this.recognizeForm.studentNo = '';
            },
            previewSheetFile() {
                const url = this.sheetPreviewUrl(this.recognizeForm.fileUrl);
                if (!url) return;
                window.open(url, '_blank');
            },
            async retryRecognize() {
                if (!this.recognizeForm.sheetId) return;
                this.recognizeSaving = true;
                try {
                    const res = await this.$Api.ExamTask.retryStudentSheet({ sheetId: this.recognizeForm.sheetId });
                    if (!isApiOk(res)) {
                        this.$message.error(apiMsg(res) || '重新识别失败');
                        return;
                    }
                    this.$message.success('已重新提交识别，请稍后查看结果');
                    this.recognizeVisible = false;
                    await this.fetchImportedSheets();
                } catch (e) {
                    this.$message.error('重新识别失败');
                } finally {
                    this.recognizeSaving = false;
                }
            },
            async saveRecognize() {
                if (!this.recognizeForm.cls) {
                    this.$message.warning('请选择班级');
                    return;
                }
                if (!this.recognizeForm.studentNo) {
                    this.$message.warning('请选择该班学生');
                    return;
                }
                const student = this.recognizeNameOptions.find((s) => s.studentNo === this.recognizeForm.studentNo);
                this.recognizeSaving = true;
                try {
                    const res = await this.$Api.ExamTask.confirmStudentSheet({
                        sheetId: this.recognizeForm.sheetId,
                        studentNo: this.recognizeForm.studentNo,
                        name: student ? student.name : undefined,
                        remark: this.recognizeForm.note,
                    });
                    if (!isApiOk(res)) {
                        this.$message.error(apiMsg(res) || '确认匹配失败');
                        return;
                    }
                    this.recognizeVisible = false;
                    this.$message.success('已确认「' + (student ? student.name : '') + ' / ' + this.recognizeForm.studentNo + '」');
                    await this.fetchImportedSheets();
                } catch (e) {
                    this.$message.error('确认匹配失败');
                } finally {
                    this.recognizeSaving = false;
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    @primary: #409EFF;
    @primary-light: #ECF5FF;
    @success: #67C23A;
    @warning: #E6A23C;
    @danger: #F56C6C;
    @bg: #F5F7FA;
    @text-primary: #303133;
    @text-regular: #606266;
    @text-secondary: #909399;
    @border-light: #EBEEF5;
    @shadow-light: 0 2px 12px rgba(0, 0, 0, 0.08);
    @radius: 8px;

    .sg {
        min-height: 100%;
    }

    .sg-main {
        max-width: 1400px;
        margin: 0 auto;
        padding: 16px 20px 40px;
    }

    .sg-project-name-bar {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
        padding: 2px 0 4px;
    }

    .sg-project-name-icon {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        background: @primary-light;
        color: @primary;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .sg-project-name-title {
        font-size: 18px;
        font-weight: 700;
        color: @text-primary;
        line-height: 1.45;
        margin: 0;
        letter-spacing: -0.02em;
        flex: 1;
        min-width: 0;
    }

    .sg-stats-row {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
        margin-bottom: 16px;
    }

    .sg-stat-card {
        background: #fff;
        border-radius: @radius;
        box-shadow: @shadow-light;
        padding: 16px 20px;
        text-align: center;
    }

    .sg-stat-value {
        font-size: 28px;
        font-weight: 700;
        line-height: 1.2;
        margin-bottom: 6px;

        &.is-total {
            color: @primary;
        }

        &.is-done {
            color: @success;
        }

        &.is-doing {
            color: @warning;
        }

        &.is-pending {
            color: #79BBFF;
        }
    }

    .sg-stat-label {
        font-size: 13px;
        color: @text-secondary;
    }

    .sg-panel {
        background: #fff;
        border-radius: @radius;
        box-shadow: @shadow-light;
        overflow: hidden;
        margin-bottom: 16px;
    }

    .sg-panel-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 16px;
        border-bottom: 1px solid @border-light;
        flex-wrap: wrap;
        gap: 10px;
    }

    .sg-panel-title {
        font-size: 15px;
        font-weight: 600;
        color: @text-primary;
    }

    .sg-filter-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0;
        flex-wrap: wrap;

        /deep/ .el-form-item {
            margin-bottom: 0;
            margin-right: 10px;
            vertical-align: middle;
        }

        /deep/ .el-form-item__content {
            line-height: 32px;
        }
    }

    .sg-filter-left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .sg-paper-filter {
        justify-content: flex-end;
        padding: 14px 16px 12px;

        /deep/ .el-form-item:last-child {
            margin-right: 0;
        }
    }

    .sg-pagination {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        padding: 14px 16px;
        border-top: 1px solid @border-light;

        /deep/ .pagination {
            margin: 0;
        }
    }

    .sg-pagination-info {
        font-size: 13px;
        color: @text-secondary;
        line-height: 30px;
    }

    .sg-delete-btn {
        color: @danger;

        &:hover,
        &:focus {
            color: #f78989;
        }
    }

    .sg-alert {
        margin-bottom: 16px;
    }

    .sg-detail-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;
        padding: 16px;
        margin-bottom: 16px;
    }

    .sg-detail-sub {
        margin-left: 8px;
        color: @text-secondary;
        font-size: 13px;
        font-weight: 400;
    }

    .sg-chart-placeholder {
        background: @bg;
        padding: 32px 24px 48px;
        text-align: center;
    }

    .sg-chart-caption {
        font-size: 14px;
        color: @text-secondary;
    }

    .sg-chart-bar {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        gap: 8px;
        height: 180px;
        margin-top: 20px;
    }

    .sg-bar {
        width: 40px;
        background: @primary;
        border-radius: 4px 4px 0 0;
        position: relative;

        &.is-green {
            background: @success;
        }
    }

    .sg-bar-label {
        position: absolute;
        bottom: -24px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        color: @text-secondary;
        white-space: nowrap;
    }

    .sg-bar-value {
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        color: @text-primary;
        font-weight: 500;
    }

    .sg-score-meta {
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
        margin-bottom: 16px;
        padding: 12px 16px;
        background: @bg;
        border-radius: 8px;
        font-size: 13px;
        color: @text-regular;
    }

    .sg-form-hint {
        font-size: 12px;
        color: @text-secondary;
        line-height: 1.5;
        margin-top: 4px;
    }

    .sg-import-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        font-size: 15px;
        font-weight: 500;
    }

    .sg-import-result-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        .ok {
            color: @success;
            font-weight: 500;
        }
    }

    .sg-create-footer {
        display: block;
        overflow: hidden;
    }

    .sg-import-pending {
        text-align: center;
        padding: 48px 16px;
        color: @text-regular;
        background: @bg;
        border-radius: @radius;

        i {
            font-size: 28px;
            color: @primary;
        }

        div {
            margin-top: 12px;
            font-size: 14px;
        }

        p {
            margin: 8px 0 0;
            font-size: 12px;
            color: @text-secondary;
        }
    }

    .sg-page-unchecked {
        font-size: 12px;
        color: @text-secondary;
    }

    .sg-steps-wrap.is-editable {
        /deep/ .el-step__head,
        /deep/ .el-step__title {
            cursor: pointer;
        }
    }

    .sg-step-hint {
        float: left;
        line-height: 32px;
        font-size: 13px;
        color: @text-secondary;
    }

    .sg-table-fit {
        width: 100%;

        /deep/ .el-table__body-wrapper {
            overflow-x: hidden;
        }
    }

    .sg-steps-wrap {
        margin-bottom: 16px;
        padding: 10px 12px 6px;
        background: #f7f9fc;
        border-radius: 8px;

        /deep/ .el-step__title {
            font-size: 13px;
            line-height: 1.3;
        }

        /deep/ .el-step__head {
            margin-bottom: 2px;
        }

        /deep/ .el-steps {
            margin-bottom: 0;
        }
    }

    .sg-create-form {
        /deep/ .el-input__inner,
        /deep/ .el-textarea__inner {
            border-radius: 6px;
        }
    }

    .sg-form-section {
        margin-bottom: 14px;
        padding: 14px 14px 2px;
        border: 1px solid #ebeef5;
        border-radius: 8px;
        background: #fafbfd;
    }

    .sg-form-section-title {
        font-size: 14px;
        font-weight: 600;
        color: @text-primary;
        margin-bottom: 12px;
    }

    .sg-filter-row {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .sg-filter-stage {
        width: 108px;
        flex: 0 0 108px;
    }

    .sg-filter-subject {
        width: 108px;
        flex: 0 0 108px;
    }

    .sg-filter-grade {
        width: 88px;
        flex: 0 0 88px;
    }

    .sg-filter-space {
        flex: 1;
        min-width: 0;
    }

    .sg-form-pair {
        /deep/ .sg-pair-right .el-form-item__label {
            text-align: right;
        }
    }

    .sg-student-upload {
        width: 100%;

        /deep/ .el-upload,
        /deep/ .el-upload-dragger {
            width: 100%;
        }

        /deep/ .el-upload-dragger {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: auto;
            min-height: 168px;
            padding: 28px 16px 20px;
            background: #f8fbff;
            border: 1px dashed #c6e2ff;
            border-radius: 8px;
        }

        /deep/ .el-icon-upload {
            margin: 0 0 10px;
            font-size: 40px;
            color: @primary;
            line-height: 1;
        }

        /deep/ .el-upload__text {
            margin: 0;
            color: @text-regular;
        }
    }

    .sg-upload-inline-tip {
        margin-top: 10px;
        font-size: 12px;
        color: @text-secondary;
        line-height: 1.4;
    }

    /deep/ .sg-create-dialog {
        .el-dialog__header {
            border-bottom: 1px solid #ebeef5;
            padding-bottom: 14px;
        }

        .el-dialog__body {
            padding-top: 16px;
        }

        .el-dialog__footer {
            border-top: 1px solid #ebeef5;
            padding-top: 14px;
        }
    }

    .sg-recognize-label {
        font-weight: 500;
        margin-bottom: 10px;
    }

    .sg-recognize-preview {
        background: @bg;
        border-radius: 8px;
        padding: 24px 16px;
        min-height: 220px;
        text-align: center;
    }

    .sg-recognize-hint {
        margin-top: 12px;
        font-size: 12px;
        color: @text-secondary;
    }

    .sg-recognize-img {
        max-width: 100%;
        max-height: 220px;
        object-fit: contain;
    }

    /deep/ .el-tabs__header {
        margin: 0 0 16px;
    }

    /deep/ .el-table {
        border: none;

        &::before {
            display: none;
        }
    }

    /deep/ .el-table__header thead th {
        color: #000;
        font-weight: 400;
        background-color: RGBA(250, 251, 255, 1);
    }

    /deep/ .el-dialog__footer {
        overflow: hidden;
    }

    @media (max-width: 1100px) {
        .sg-stats-row {
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>

<style lang="less">
    .sg-task-notify.el-notification {
        border-left: 4px solid #f56c6c;
        background: #fef0f0;

        .el-notification__title {
            font-weight: 600;
            color: #303133;
        }

        .el-notification__content {
            color: #606266;
        }
    }
</style>
